$wj([38],{

/***/ 1566:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PanelType;
(function (PanelType) {
    /**
     * Renders the panel in 'small' mode, anchored to the far side (right in LTR mode), and has a fluid width.
     * Only used on Small screen breakpoints.
     * Small: 320-479px width (full screen), 16px Left/Right padding
     * Medium: <unused>
     * Large: <unused>
     * XLarge: <unused>
     * XXLarge: <unused>
     */
    PanelType[PanelType["smallFluid"] = 0] = "smallFluid";
    /**
     * Renders the panel in 'small' mode, anchored to the far side (right in LTR mode), and has a fixed width.
     * Small: 272px width, 16px Left/Right padding
     * Medium: 340px width, 16px Left/Right padding
     * Large: 340px width, 32px Left/Right padding
     * XLarge: 340px width, 32px Left/Right padding
     * XXLarge: 340px width, 40px Left/Right padding
     */
    PanelType[PanelType["smallFixedFar"] = 1] = "smallFixedFar";
    /**
     * Renders the panel in 'small' mode, anchored to the near side (left in LTR mode), and has a fixed width.
     * Small: 272px width, 16px Left/Right padding
     * Medium: 272px width, 16px Left/Right padding
     * Large: 272px width, 32px Left/Right padding
     * XLarge: 272px width, 32px Left/Right padding
     * XXLarge: 272px width, 32px Left/Right padding
     */
    PanelType[PanelType["smallFixedNear"] = 2] = "smallFixedNear";
    /**
     * Renders the panel in 'medium' mode, anchored to the far side (right in LTR mode).
     * Small: <adapts to smallFluid>
     * Medium: <adapts to smallFixedFar>
     * Large: 48px fixed left margin, 32px Left/Right padding
     * XLarge: 644px width, 32px Left/Right padding
     * XXLarge: 643px width, 40px Left/Right padding
     */
    PanelType[PanelType["medium"] = 3] = "medium";
    /**
     * Renders the panel in 'large' mode, anchored to the far side (right in LTR mode), and is fluid at XXX-Large breakpoint.
     * Small: <adapts to smallFluid>
     * Medium:  <adapts to smallFixedFar>
     * Large: <adapts to medium>
     * XLarge: 48px fixed left margin, 32px Left/Right padding
     * XXLarge: 48px fixed left margin, 32px Left/Right padding
     * XXXLarge: 48px fixed left margin, (no redlines for padding, assuming previous breakpoint)
     */
    PanelType[PanelType["large"] = 4] = "large";
    /**
     * Renders the panel in 'large' mode, anchored to the far side (right in LTR mode), and is fixed at XXX-Large breakpoint.
     * Small: <adapts to smallFluid>
     * Medium:  <adapts to smallFixedFar>
     * Large: <adapts to medium>
     * XLarge: 48px fixed left margin, 32px Left/Right padding
     * XXLarge: 48px fixed left margin, 32px Left/Right padding
     * XXXLarge: 940px width, (no redlines for padding, assuming previous breakpoint)
     */
    PanelType[PanelType["largeFixed"] = 5] = "largeFixed";
    /**
     * Renders the panel in 'extra large' mode, anchored to the far side (right in LTR mode).
     * Small: <adapts to smallFluid>
     * Medium: <adapts to smallFixedFar>
     * Large: <adapts to medium>
     * XLarge: <adapts to large>
     * XXLarge: 176px fixed left margin, 40px Left/Right padding
     * XXXLarge: 176px fixed left margin, 40px Left/Right padding
     */
    PanelType[PanelType["extraLarge"] = 6] = "extraLarge";
    /**
     * Renders the panel in 'custom' mode using customWidth, anchored to the far side (right in LTR mode).
     * Small: <adapts to smallFluid>
     * Medium: <adapts to smallFixedFar>
     * Large: 48px fixed left margin, 32px Left/Right padding
     * XLarge: 644px width, 32px Left/Right padding
     * XXLarge: 643px width, 40px Left/Right padding
     */
    PanelType[PanelType["custom"] = 7] = "custom";
})(PanelType = exports.PanelType || (exports.PanelType = {}));
//# sourceMappingURL=Panel.types.js.map

/***/ }),

/***/ 1737:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var index_1 = __webpack_require__(20);
var keys = ['options_appearance_weekstartdayLabel', 'options_appearance_dimpasteventsLabel', 'optionTitle_appearance', 'optionTitle_weather', 'optionTitle_eventsForEmail', 'optionTitle_reminders', 'optionSubcategory_personalization', 'optionSubcategory_automaticProcessing', 'optionSubcategory_notifications', 'options_txp_description', 'options_txp_disable', 'options_txp_enable', 'options_txp_addEventsTitle', 'options_txp_flights', 'options_txp_hotelReservations', 'options_txp_carRentals', 'options_txp_packageDelivery', 'options_txp_diningReservations', 'options_txp_events', 'options_txp_bills', 'options_txp_markEventsPrivate', 'options_weather_toggleLabel', 'options_weather_enabled', 'options_weather_disabled', 'options_weather_unitLabel', 'options_weather_fahrenheit', 'options_weather_celsius', 'optionCategory_General', 'optionCategory_Mail', 'optionCategory_Calendar', 'optionCategory_People', 'optionTitle_personal', 'optionTitle_mailboxUsage', 'optionTitle_regional', 'optionTitle_Theme', 'optionSearch_Theme', 'optionTitle_accessibility', 'optionTitle_shortcuts', 'optionTitle_skypeNotifications', 'options_premium_Title', 'options_premium_subTitle1', 'options_premium_StorageContentPart1', 'options_premium_StorageContentPart2', 'options_premium_subTitle2', 'options_premium_SubscriptionContent', 'options_premium_buttonText', 'options_premium_subTitle3', 'options_premium_AdvancedSecurityContent_part1', 'options_premium_AdvancedSecurityContent_part2', 'options_premium_AdvancedSecurityContent_LearnMore', 'option_regional_language', 'option_regional_renameDefaultFolders', 'option_regional_languageReload', 'option_regional_languageHotReload', 'option_regional_dateFormat', 'option_regional_timeFormat', 'option_regional_timeZone', 'options_shortcuts_description', 'options_shortcuts_label', 'options_shortcut_choice_hotmail', 'options_shortcut_choice_yahoo', 'options_shortcut_choice_gmail', 'options_shortcut_choice_outlook', 'options_shortcut_choice_off', 'options_skype_ImNotifityTitle', 'options_skype_CallNotifityTitle', 'options_skype_NotifyAll', 'options_skype_NotifyToast', 'options_skype_ImNotifyNone', 'optionSubcategory_account', 'optionSubcategory_appearance', 'optionSubcategory_configuration', 'optionSubcategory_skype', 'optionSubcategory_premium', 'themeTitleLabel', 'themeDisplayName_angular', 'themeDisplayName_balloons', 'themeDisplayName_base', 'themeDisplayName_beach', 'themeDisplayName_black', 'themeDisplayName_blueberry', 'themeDisplayName_blueprint', 'themeDisplayName_bricks', 'themeDisplayName_cats', 'themeDisplayName_chevron', 'themeDisplayName_circuit', 'themeDisplayName_comic', 'themeDisplayName_contrast', 'themeDisplayName_cordovan', 'themeDisplayName_crayon', 'themeDisplayName_cubes', 'themeDisplayName_cubism', 'themeDisplayName_darkcordovan', 'themeDisplayName_darkorange', 'themeDisplayName_diamonds', 'themeDisplayName_far', 'themeDisplayName_grape', 'themeDisplayName_jelly', 'themeDisplayName_lightblue', 'themeDisplayName_lightgreen', 'themeDisplayName_lite', 'themeDisplayName_mediumdarkblue', 'themeDisplayName_minimal', 'themeDisplayName_modern', 'themeDisplayName_mountain', 'themeDisplayName_orange', 'themeDisplayName_paint', 'themeDisplayName_pink', 'themeDisplayName_pixel', 'themeDisplayName_polka', 'themeDisplayName_pomegranate', 'themeDisplayName_primary', 'themeDisplayName_raspberry', 'themeDisplayName_robot', 'themeDisplayName_simple', 'themeDisplayName_spectrum', 'themeDisplayName_strawberry', 'themeDisplayName_super', 'themeDisplayName_teagarden', 'themeDisplayName_teal', 'themeDisplayName_watermelon', 'themeDisplayName_whale', 'themeDisplayName_whimsical', 'themeDisplayName_wntrlnd', 'themeDisplayName_wrld', 'themeExpandLabel', 'themeCollapseLabel', 'options_attachmentPreferences_localLabel', 'options_attachmentPreferences_cloudLabel', 'options_attachmentPreferences_askOption', 'options_attachmentPreferences_shareOption', 'options_attachmentPreferences_attachOption', 'options_blockAllow_moveEmail', 'options_blockAllow_dontMoveEmail', 'options_blockAllow_trustEmailFromContacts', 'options_blockAllow_onlyTrustEmailFromSafeSenders', 'options_blockAllow_junkMailFilteringEnabled', 'options_blockAllow_junkMailFilteringDisabled', 'options_callout_addStorageAccount_title', 'options_callout_addStorageAccount_body', 'options_callout_addStorageAccount_button', 'options_common_addSenderOrDomainPlaceholder', 'options_common_addSenderPlaceholder', 'options_common_addDomainPlaceholder', 'options_common_addButtonLabel', 'options_common_invalidAddressError', 'options_common_invalidDomainError', 'options_common_invalidAddressOrDomainError', 'options_common_invalidIsSelfError', 'options_common_editEmailAddressOrDomainButtonTitle', 'options_common_removeEmailAddressOrDomainButtonTitle', 'options_conversations_sortOrderLabel', 'options_conversations_sortOrderTop', 'options_conversations_sortOrderBottom', 'options_conversations_quick_label', 'options_conversations_quick_tooltip', 'options_conversations_quick_sortOrderTop', 'options_conversations_quick_sortOrderBottom', 'options_conversations_quick_messageView', 'options_conversations_deletedItemsLabel', 'options_conversations_deletedItemsShow', 'options_conversations_deletedItemsHide', 'options_dateHeaders_enabled', 'options_dateHeaders_disabled', 'options_dateHeaders_quick_label', 'options_focused_label', 'options_focused_enabled', 'options_focused_disabled', 'options_format_showBcc', 'options_format_showFrom', 'options_format_formatLabel_front', 'options_format_formatLabel_back', 'options_format_dropdown_html', 'options_format_dropdown_plaintext', 'options_format_sampleText_1', 'options_format_sampleText_2', 'options_inboxRules_description', 'options_inboxRules_if', 'options_inboxRules_exceptWhen', 'options_inboxRules_and', 'options_inboxRules_or', 'options_inboxRules_addNewRule', 'options_inboxRules_noRules', 'options_inboxRules_loadingRulesError', 'options_inboxRules_deleteRuleAriaText', 'options_inboxRules_ruleDisabledAriaText', 'options_inboxRules_ruleEnabledAriaText', 'options_inboxRules_tryAgain', 'options_inboxRules_generateReport', 'options_inboxRules_generateReportPending', 'options_inboxRules_generateReportSuccess', 'options_inboxRules_generateReportFail', 'options_inboxRules_backToRulesList', 'options_inboxRules_clauseValueDropdownPlaceholder', 'options_inboxRules_clauseTypeDropdownPlaceholder', 'options_inboxRules_addressIncludesOptionPlaceholder', 'options_inboxRules_containsOptionPlaceholder', 'options_inboxRules_conditionsHeader', 'options_inboxRules_conditionsInfo', 'options_inboxRules_selectCondition', 'options_inboxRules_addCondition', 'options_inboxRules_actionsHeader', 'options_inboxRules_actionsInfo', 'options_inboxRules_selectAction', 'options_inboxRules_addAction', 'options_inboxRules_exceptionsHeader', 'options_inboxRules_exceptionsInfo', 'options_inboxRules_selectException', 'options_inboxRules_addException', 'options_inboxRules_addExceptionSection', 'options_inboxRules_nameRule', 'options_inboxRules_ignoreSubsequentRules', 'options_inboxRules_stopProcessingRules', 'options_inboxRules_learnMore', 'options_inboxRules_addresses', 'options_inboxRules_people', 'options_inboxRules_from', 'options_inboxRules_to', 'options_inboxRules_myNameIs', 'options_inboxRules_toOrCcLine', 'options_inboxRules_onlyRecipient', 'options_inboxRules_toLine', 'options_inboxRules_ccLine', 'options_inboxRules_notToLine', 'options_inboxRules_fromAccount', 'options_inboxRules_subject', 'options_inboxRules_subjectIncludes', 'options_inboxRules_subjectOrBodyIncludes', 'options_inboxRules_includesWords', 'options_inboxRules_inBody', 'options_inboxRules_inSenderAddress', 'options_inboxRules_inRecipientAddress', 'options_inboxRules_inMessageHeader', 'options_inboxRules_markedWith', 'options_inboxRules_importance', 'options_inboxRules_sensitivity', 'options_inboxRules_low', 'options_inboxRules_normal', 'options_inboxRules_high', 'options_inboxRules_personal', 'options_inboxRules_private', 'options_inboxRules_companyConfidential', 'options_inboxRules_messageIncludes', 'options_inboxRules_classification', 'options_inboxRules_flag', 'options_inboxRules_any', 'options_inboxRules_call', 'options_inboxRules_doNotForward', 'options_inboxRules_followUp', 'options_inboxRules_forYourInformation', 'options_inboxRules_forward', 'options_inboxRules_noResponseNecessary', 'options_inboxRules_read', 'options_inboxRules_reply', 'options_inboxRules_replyToAll', 'options_inboxRules_review', 'options_inboxRules_type', 'options_inboxRules_automaticReply', 'options_inboxRules_automaticallyForwarded', 'options_inboxRules_encrypted', 'options_inboxRules_invitation', 'options_inboxRules_eventResponse', 'options_inboxRules_permissionControlled', 'options_inboxRules_voiceMail', 'options_inboxRules_signed', 'options_inboxRules_requestForApproval', 'options_inboxRules_readReceipt', 'options_inboxRules_nonDeliveryReport', 'options_inboxRules_attachment', 'options_inboxRules_messageSize', 'options_inboxRules_atLeast', 'options_inboxRules_atMost', 'options_inboxRules_kb', 'options_inboxRules_received', 'options_inboxRules_before', 'options_inboxRules_after', 'options_inboxRules_organize', 'options_inboxRules_moveTo', 'options_inboxRules_copyTo', 'options_inboxRules_delete', 'options_inboxRules_pinToTop', 'options_inboxRules_markMessage', 'options_inboxRules_junk', 'options_inboxRules_category', 'options_inboxRules_route', 'options_inboxRules_forwardTo', 'options_inboxRules_forwardAsAttachmentTo', 'options_inboxRules_redirectTo', 'options_inboxRules_sendTextMessageTo', 'options_inboxRules_emptyNameError', 'options_inboxRules_emptyDropdownError', 'options_inboxRules_emptyPersonaError', 'options_inboxRules_emptyFromError', 'options_inboxRules_emptyToError', 'options_inboxRules_emptyPhraseError', 'options_inboxRules_messageSizeNotANumber', 'options_inboxRules_messageSizeTooLarge', 'options_inboxRules_messageSizeInvalid', 'options_inboxRules_fixBrokenRuleError', 'options_inboxRules_differentOutlookError', 'options_inboxRules_manageRules', 'options_inlinePreviews_enabled', 'options_inlinePreviews_disabled', 'options_inlinePreviews_quick_setting_label', 'options_junk_reportDescription', 'options_junk_reportLabel', 'options_junk_reportOptionAsk', 'options_junk_reportOptionAlways', 'options_junk_reportNever', 'options_junk_shareDescription', 'options_junk_shareHelpLink', 'options_junk_shareOptionAlways', 'options_junk_shareOptionNever', 'options_junkEmail_blockedSenders', 'options_junkEmail_blockedDomains', 'options_mail_linkPreviewDescription', 'options_mail_linkPreviewHelpLink', 'options_mail_linkPreviewCheckboxLabel', 'options_mail_markAsReadInstant', 'options_mail_markAsReadDelayed', 'options_mail_markAsReadSelectionChange', 'options_mail_markAsReadNever', 'option_mail_AfterMove_Next', 'option_mail_AfterMove_Previous', 'option_mail_AfterMove_ReturnToView', 'option_mail_AfterMove_Title', 'option_mail_NotifyTitle', 'option_mail_NotifySound', 'option_mail_NotifyToast', 'option_mail_LogOutTitle', 'option_mail_EmptyDeletedOnLogOut', 'options_messageOrganization_positionLabel', 'options_messageOrganization_showAsConversation', 'options_messageOrganization_showAsMessage', 'options_messageList_previewLabel', 'options_messageList_previewShow', 'options_messageList_previewHide', 'optionSearchTerms_blockedDomains', 'optionSearchTerms_blockedSenders', 'optionTitle_automaticReplies', 'optionTitle_sweep', 'optionTitle_junk', 'optionTitle_signature', 'optionTitle_markAsRead', 'optionTitle_reply', 'optionTitle_message', 'optionTitle_readReceipts', 'optionTitle_quickActions', 'optionTitle_blockAllow', 'optionTitle_connected', 'optionTitle_forwarding', 'optionTitle_attachmentPreferences', 'optionTitle_storageAccounts', 'optionTitle_conversations', 'optionTitle_focusedInbox', 'optionTitle_messageFormat', 'optionTitle_messageList', 'optionTitle_readingPane', 'optionTitle_linkPreview', 'optionTitle_quickSuggestions', 'optionTitle_inlinePreviews', 'optionTitle_dateHeaders', 'optionTitle_blockedDomains', 'optionTitle_blockedSenders', 'optionTitle_trustedSenders', 'optionTitle_enableJunkMailFiltering', 'optionTitle_blockedSendersAndDomains', 'optionTitle_messageOrganization', 'optionTitle_inboxRules', 'optionTitle_senderSubjectOrder', 'optionTitle_messagePreview', 'optionTitle_senderImage', 'optionTitle_readSurfaceActions', 'optionTitle_composeSurfaceActions', 'options_mail_quickSuggestionsDescription', 'options_mail_quickSuggestionsEnable', 'options_mail_quickSuggestionsLocation', 'options_readingPane_positionLabel', 'options_readingPane_positionRight', 'options_readingPane_positionBottom', 'options_readingPane_positionHide', 'options_readingPane_afterMove_next', 'options_readingPane_afterMove_previous', 'options_readingPane_afterMove_returnToView', 'options_readingPane_afterMove_title', 'options_readingPane_actionOnLoadLabel', 'options_readingPane_actionOnLoadFirstItem', 'options_readingPane_actionOnLoadNoAction', 'options_readingPane_quickSetting_effortless', 'options_readingPane_quickSetting_label', 'options_readingPane_quickSetting_classic', 'options_readingPane_quickSetting_right', 'options_readingPane_quickSetting_bottom', 'options_mail_ReadReceiptPrompt', 'options_mail_ReadReceiptAlways', 'options_mail_ReadReceiptNever', 'options_mail_ReadReceiptTitle', 'options_mail_Reply', 'options_mail_ReplyAll', 'options_mail_ReplyOptionLabel', 'options_messageList_senderImageLabel', 'options_messageList_showSenderImage', 'options_messageList_hideSenderImage', 'options_messageList_firstLineLabel', 'options_messageList_firstLineSender', 'options_messageList_firstLineSubject', 'options_signature_title', 'options_signature_signNewMails', 'options_signature_signReplies', 'options_storageAccounts_addAccountHeader', 'options_storageAccounts_primaryAccount', 'options_storageAccounts_otherAccounts', 'optionSubcategory_automation', 'optionSubcategory_handling', 'optionSubcategory_accounts', 'optionSubcategory_attachments', 'optionSubcategory_layout', 'optionSubcategory_messageContent', 'optionSubcategory_rules', 'optionSubcategory_blockAllow', 'optionSubcategory_junkEmail', 'optionSubcategory_surfaceActions', 'options_title', 'optionsConfirmationDialog_title', 'optionsConfirmationDialog_subtitle', 'optionsConfirmationDialog_save', 'optionsConfirmationDialog_discard', 'optionsConfirmationDialog_cancel', 'optionsFlex_title', 'optionsFlex_searchPlaceholder', 'optionsFlex_goToFullOptions', 'optionsFull_save', 'optionsFull_cancel', 'optionsFull_searchPlaceholder', 'optionsFull_goToQuickOptions', 'optionsFull_subCategory_loading', 'optionsFull_subCategory_error'];
var stringModule = index_1.registerStringPackage('owa-options-strings', null, keys);
var exportedObject = {
    stringsModule: stringModule,
};
keys.forEach(function (key) {
    Object.defineProperty(exportedObject, key, { get: function () { return stringModule.strings.get(key); } });
});
exports.default = exportedObject;


/***/ }),

/***/ 1741:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1752), exports);
//# sourceMappingURL=TextField.js.map

/***/ }),

/***/ 1747:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1756), exports);
//# sourceMappingURL=Panel.js.map

/***/ }),

/***/ 1752:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1753), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1753:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Label_1 = __webpack_require__(1559);
var Icon_1 = __webpack_require__(43);
var Utilities_1 = __webpack_require__(7);
var stylesImport = __webpack_require__(1754);
var styles = stylesImport;
var Styling_1 = __webpack_require__(21);
var TextField = /** @class */ (function (_super) {
    tslib_1.__extends(TextField, _super);
    function TextField(props) {
        var _this = _super.call(this, props) || this;
        _this._warnDeprecations({
            'iconClass': 'iconProps',
            'addonString': 'prefix',
            'onRenderAddon': 'onRenderPrefix'
        });
        _this._warnMutuallyExclusive({
            'value': 'defaultValue'
        });
        _this._id = Utilities_1.getId('TextField');
        _this._descriptionId = Utilities_1.getId('TextFieldDescription');
        _this.state = {
            value: props.value || props.defaultValue || '',
            isFocused: false,
            errorMessage: ''
        };
        _this._onInputChange = _this._onInputChange.bind(_this);
        _this._onFocus = _this._onFocus.bind(_this);
        _this._onBlur = _this._onBlur.bind(_this);
        _this._delayedValidate = _this._async.debounce(_this._validate, _this.props.deferredValidationTime);
        _this._lastValidation = 0;
        _this._isDescriptionAvailable = false;
        return _this;
    }
    Object.defineProperty(TextField.prototype, "value", {
        /**
         * Gets the current value of the text field.
         */
        get: function () {
            return this.state.value;
        },
        enumerable: true,
        configurable: true
    });
    TextField.prototype.componentDidMount = function () {
        this._isMounted = true;
        this._adjustInputHeight();
        if (this.props.validateOnLoad) {
            this._validate(this.state.value);
        }
    };
    TextField.prototype.componentWillReceiveProps = function (newProps) {
        var onBeforeChange = this.props.onBeforeChange;
        if (newProps.value !== undefined && newProps.value !== this.state.value) {
            if (onBeforeChange) {
                onBeforeChange(newProps.value);
            }
            this._latestValue = newProps.value;
            this.setState({
                value: newProps.value,
                errorMessage: ''
            });
            this._delayedValidate(newProps.value);
        }
    };
    TextField.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    TextField.prototype.render = function () {
        var _a = this.props, className = _a.className, description = _a.description, disabled = _a.disabled, iconClass = _a.iconClass, iconProps = _a.iconProps, multiline = _a.multiline, required = _a.required, underlined = _a.underlined, borderless = _a.borderless, addonString = _a.addonString, // @deprecated
        prefix = _a.prefix, suffix = _a.suffix, _b = _a.onRenderAddon, onRenderAddon = _b === void 0 ? this._onRenderAddon : _b, // @deprecated
        _c = _a.onRenderPrefix, // @deprecated
        onRenderPrefix = _c === void 0 ? this._onRenderPrefix : _c, _d = _a.onRenderSuffix, onRenderSuffix = _d === void 0 ? this._onRenderSuffix : _d, _e = _a.onRenderLabel, onRenderLabel = _e === void 0 ? this._onRenderLabel : _e;
        var isFocused = this.state.isFocused;
        var errorMessage = this._errorMessage;
        this._isDescriptionAvailable = Boolean(description || errorMessage);
        var renderProps = tslib_1.__assign({}, this.props, { componentId: this._id });
        var textFieldClassName = Utilities_1.css('ms-TextField', styles.root, className, (_f = {},
            _f['is-required ' + styles.rootIsRequiredLabel] = this.props.label && required,
            _f['is-required ' + styles.rootIsRequiredPlaceholderOnly] = !this.props.label && required,
            _f['is-disabled ' + styles.rootIsDisabled] = disabled,
            _f['is-active ' + styles.rootIsActive] = isFocused,
            _f['ms-TextField--multiline ' + styles.rootIsMultiline] = multiline,
            _f['ms-TextField--underlined ' + styles.rootIsUnderlined] = underlined,
            _f['ms-TextField--borderless ' + styles.rootIsBorderless] = borderless,
            _f));
        return (React.createElement("div", { className: textFieldClassName },
            React.createElement("div", { className: Utilities_1.css('ms-TextField-wrapper', styles.wrapper, underlined ? errorMessage && styles.invalid : '') },
                onRenderLabel(renderProps, this._onRenderLabel),
                React.createElement("div", { className: Utilities_1.css('ms-TextField-fieldGroup', styles.fieldGroup, isFocused && styles.fieldGroupIsFocused, errorMessage && styles.invalid) },
                    (addonString !== undefined || this.props.onRenderAddon) && (React.createElement("div", { className: Utilities_1.css('ms-TextField-prefix', styles.fieldPrefixSuffix) }, onRenderAddon(this.props, this._onRenderAddon))),
                    (prefix !== undefined || this.props.onRenderPrefix) && (React.createElement("div", { className: Utilities_1.css('ms-TextField-prefix', styles.fieldPrefixSuffix) }, onRenderPrefix(this.props, this._onRenderPrefix))),
                    multiline ? this._renderTextArea() : this._renderInput(),
                    (iconClass || iconProps) && React.createElement(Icon_1.Icon, tslib_1.__assign({ className: Utilities_1.css(iconClass, styles.icon) }, iconProps)),
                    (suffix !== undefined || this.props.onRenderSuffix) && (React.createElement("div", { className: Utilities_1.css('ms-TextField-suffix', styles.fieldPrefixSuffix) }, onRenderSuffix(this.props, this._onRenderSuffix))))),
            this._isDescriptionAvailable &&
                React.createElement("span", { id: this._descriptionId },
                    description && React.createElement("span", { className: Utilities_1.css('ms-TextField-description', styles.description) }, description),
                    errorMessage &&
                        React.createElement("div", null,
                            React.createElement(Utilities_1.DelayedRender, null,
                                React.createElement("p", { className: Utilities_1.css('ms-TextField-errorMessage', Styling_1.AnimationClassNames.slideDownIn20, styles.errorMessage) },
                                    React.createElement("span", { "aria-live": 'assertive', className: styles.errorText, "data-automation-id": 'error-message' }, errorMessage)))))));
        var _f;
    };
    /**
     * Sets focus on the text field
     */
    TextField.prototype.focus = function () {
        if (this._textElement) {
            this._textElement.focus();
        }
    };
    /**
     * Selects the text field
     */
    TextField.prototype.select = function () {
        if (this._textElement) {
            this._textElement.select();
        }
    };
    /**
     * Sets the selection start of the text field to a specified value
     */
    TextField.prototype.setSelectionStart = function (value) {
        if (this._textElement) {
            this._textElement.selectionStart = value;
        }
    };
    /**
     * Sets the selection end of the text field to a specified value
     */
    TextField.prototype.setSelectionEnd = function (value) {
        if (this._textElement) {
            this._textElement.selectionEnd = value;
        }
    };
    Object.defineProperty(TextField.prototype, "selectionStart", {
        /**
         * Gets the selection start of the text field
         */
        get: function () {
            return this._textElement ? this._textElement.selectionStart : -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextField.prototype, "selectionEnd", {
        /**
         * Gets the selection end of the text field
         */
        get: function () {
            return this._textElement ? this._textElement.selectionEnd : -1;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the start and end positions of a selection in a text field.
     * @param start Index of the start of the selection.
     * @param end Index of the end of the selection.
     */
    TextField.prototype.setSelectionRange = function (start, end) {
        if (this._textElement) {
            this._textElement.setSelectionRange(start, end);
        }
    };
    TextField.prototype._onFocus = function (ev) {
        if (this.props.onFocus) {
            this.props.onFocus(ev);
        }
        this.setState({ isFocused: true });
        if (this.props.validateOnFocusIn) {
            this._validate(this.state.value);
        }
    };
    TextField.prototype._onBlur = function (ev) {
        if (this.props.onBlur) {
            this.props.onBlur(ev);
        }
        this.setState({ isFocused: false });
        if (this.props.validateOnFocusOut) {
            this._validate(this.state.value);
        }
    };
    TextField.prototype._onRenderLabel = function (props) {
        var label = props.label, componentId = props.componentId;
        if (label) {
            return (React.createElement(Label_1.Label, { htmlFor: componentId }, label));
        }
        return null;
    };
    // @deprecated
    TextField.prototype._onRenderAddon = function (props) {
        var addonString = props.addonString;
        return (React.createElement("span", { style: { paddingBottom: '1px' } }, addonString));
    };
    TextField.prototype._onRenderPrefix = function (props) {
        var prefix = props.prefix;
        return (React.createElement("span", { style: { paddingBottom: '1px' } }, prefix));
    };
    TextField.prototype._onRenderSuffix = function (props) {
        var suffix = props.suffix;
        return (React.createElement("span", { style: { paddingBottom: '1px' } }, suffix));
    };
    TextField.prototype._getTextElementClassName = function () {
        var textFieldClassName;
        if (this.props.multiline && !this.props.resizable) {
            textFieldClassName = Utilities_1.css('ms-TextField-field ms-TextField-field--unresizable', styles.field, styles.fieldIsUnresizable);
        }
        else {
            textFieldClassName = Utilities_1.css('ms-TextField-field', styles.field);
        }
        return Utilities_1.css(textFieldClassName, this.props.inputClassName, (_a = {},
            _a[styles.hasIcon] = !!this.props.iconClass,
            _a));
        var _a;
    };
    Object.defineProperty(TextField.prototype, "_errorMessage", {
        get: function () {
            var errorMessage = this.state.errorMessage;
            if (!errorMessage) {
                errorMessage = this.props.errorMessage;
            }
            return errorMessage;
        },
        enumerable: true,
        configurable: true
    });
    TextField.prototype._renderTextArea = function () {
        var textAreaProps = Utilities_1.getNativeProps(this.props, Utilities_1.textAreaProperties, ['defaultValue']);
        return (React.createElement("textarea", tslib_1.__assign({ id: this._id }, textAreaProps, { ref: this._resolveRef('_textElement'), value: this.state.value, onInput: this._onInputChange, onChange: this._onInputChange, className: this._getTextElementClassName(), "aria-describedby": this._isDescriptionAvailable ? this._descriptionId : null, "aria-invalid": !!this.state.errorMessage, "aria-label": this.props.ariaLabel, onFocus: this._onFocus, onBlur: this._onBlur })));
    };
    TextField.prototype._renderInput = function () {
        var inputProps = Utilities_1.getNativeProps(this.props, Utilities_1.inputProperties, ['defaultValue']);
        return (React.createElement("input", tslib_1.__assign({ type: 'text', id: this._id }, inputProps, { ref: this._resolveRef('_textElement'), value: this.state.value, onInput: this._onInputChange, onChange: this._onInputChange, className: this._getTextElementClassName(), "aria-label": this.props.ariaLabel, "aria-describedby": this._isDescriptionAvailable ? this._descriptionId : null, "aria-invalid": !!this.state.errorMessage, onFocus: this._onFocus, onBlur: this._onBlur })));
    };
    TextField.prototype._onInputChange = function (event) {
        var _this = this;
        var element = event.target;
        var value = element.value;
        // Avoid doing unnecessary work when the value has not changed.
        if (value === this._latestValue) {
            return;
        }
        this._latestValue = value;
        this.setState({
            value: value,
            errorMessage: ''
        }, function () {
            _this._adjustInputHeight();
            if (_this.props.onChanged) {
                _this.props.onChanged(value);
            }
        });
        var _a = this.props, validateOnFocusIn = _a.validateOnFocusIn, validateOnFocusOut = _a.validateOnFocusOut;
        if (!(validateOnFocusIn || validateOnFocusOut)) {
            this._delayedValidate(value);
        }
        var onBeforeChange = this.props.onBeforeChange;
        onBeforeChange(value);
    };
    TextField.prototype._validate = function (value) {
        var _this = this;
        // In case of _validate called multi-times during executing validate logic with promise return.
        if (this._latestValidateValue === value) {
            return;
        }
        this._latestValidateValue = value;
        var onGetErrorMessage = this.props.onGetErrorMessage;
        var result = onGetErrorMessage(value || '');
        if (result !== undefined) {
            if (typeof result === 'string') {
                this.setState({
                    errorMessage: result
                });
                this._notifyAfterValidate(value, result);
            }
            else {
                var currentValidation_1 = ++this._lastValidation;
                result.then(function (errorMessage) {
                    if (_this._isMounted && currentValidation_1 === _this._lastValidation) {
                        _this.setState({ errorMessage: errorMessage });
                    }
                    _this._notifyAfterValidate(value, errorMessage);
                });
            }
        }
        else {
            this._notifyAfterValidate(value, '');
        }
    };
    TextField.prototype._notifyAfterValidate = function (value, errorMessage) {
        if (this._isMounted &&
            value === this.state.value &&
            this.props.onNotifyValidationResult) {
            this.props.onNotifyValidationResult(errorMessage, value);
        }
    };
    TextField.prototype._adjustInputHeight = function () {
        if (this._textElement && this.props.autoAdjustHeight && this.props.multiline) {
            var textField = this._textElement;
            textField.style.height = '';
            var scrollHeight = textField.scrollHeight + 2; // +2 to avoid vertical scroll bars
            textField.style.height = scrollHeight + 'px';
        }
    };
    TextField.defaultProps = {
        multiline: false,
        resizable: true,
        autoAdjustHeight: false,
        underlined: false,
        borderless: false,
        onChanged: function () { },
        onBeforeChange: function () { },
        onNotifyValidationResult: function () { },
        onGetErrorMessage: function () { return undefined; },
        deferredValidationTime: 200,
        errorMessage: '',
        validateOnFocusIn: false,
        validateOnFocusOut: false,
        validateOnLoad: true,
    };
    return TextField;
}(Utilities_1.BaseComponent));
exports.TextField = TextField;
//# sourceMappingURL=TextField.js.map

/***/ }),

/***/ 1754:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = __webpack_require__(8);
load_themed_styles_1.loadStyles([{ "rawString": ".root_5c753ca1{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:none;box-shadow:none;margin:0;padding:0;position:relative}.screenReaderOnly_5c753ca1{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);border:0}.fieldGroup_5c753ca1{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:none;box-shadow:none;margin:0;padding:0;border:1px solid " }, { "theme": "inputBorder", "defaultValue": "#a6a6a6" }, { "rawString": ";background:" }, { "theme": "bodyBackground", "defaultValue": "#ffffff" }, { "rawString": ";height:32px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;position:relative}.fieldGroup_5c753ca1:hover{border-color:" }, { "theme": "inputBorderHovered", "defaultValue": "#212121" }, { "rawString": "}.fieldGroup_5c753ca1.fieldGroupIsFocused_5c753ca1{border-color:" }, { "theme": "inputFocusBorderAlt", "defaultValue": "#0078d7" }, { "rawString": "}.rootIsDisabled_5c753ca1 .fieldGroup_5c753ca1{background-color:" }, { "theme": "disabledBackground", "defaultValue": "#f4f4f4" }, { "rawString": ";border-color:" }, { "theme": "disabledBackground", "defaultValue": "#f4f4f4" }, { "rawString": ";pointer-events:none;cursor:default}@media screen and (-ms-high-contrast: active){.fieldGroup_5c753ca1:hover,.fieldGroup_5c753ca1.fieldGroupIsFocused_5c753ca1{border-color:Highlight}}.fieldGroup_5c753ca1::-ms-clear{display:none}.root_5c753ca1.rootIsDisabled_5c753ca1 .field{background-color:" }, { "theme": "disabledBackground", "defaultValue": "#f4f4f4" }, { "rawString": ";border-color:" }, { "theme": "disabledBackground", "defaultValue": "#f4f4f4" }, { "rawString": ";pointer-events:none;cursor:default}.fieldPrefixSuffix_5c753ca1{background:" }, { "theme": "neutralLighter", "defaultValue": "#f4f4f4" }, { "rawString": ";color:" }, { "theme": "neutralSecondary", "defaultValue": "#666666" }, { "rawString": ";display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:0 10px;line-height:1}.field_5c753ca1{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:none;box-shadow:none;margin:0;padding:0;font-size:14px;border-radius:0;border:none;background:none;color:" }, { "theme": "bodyText", "defaultValue": "#333333" }, { "rawString": ";padding:0 12px 0 12px;width:100%;text-overflow:ellipsis;outline:0}[dir='rtl'] .field_5c753ca1{padding:0 12px 0 12px}.field_5c753ca1:active,.field_5c753ca1:focus,.field_5c753ca1:hover{outline:0}[dir='ltr'] .field_5c753ca1.hasIcon_5c753ca1{padding-right:24px}[dir='rtl'] .field_5c753ca1.hasIcon_5c753ca1{padding-left:24px}.field_5c753ca1[disabled]{background-color:transparent;border-color:transparent;pointer-events:none;cursor:default}.field_5c753ca1 .field_5c753ca1::-webkit-input-placeholder{color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.field_5c753ca1 .field_5c753ca1:-ms-input-placeholder{color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.field_5c753ca1 .field_5c753ca1::-ms-input-placeholder{color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.field .field::-webkit-input-placeholder{color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.field .field:-ms-input-placeholder{color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.field .field::-ms-input-placeholder{color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.field_5c753ca1 .field_5c753ca1::placeholder{color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.root_5c753ca1.rootIsRequiredLabel_5c753ca1 .ms-Label::after{content:' *';color:" }, { "theme": "error", "defaultValue": "#a80000" }, { "rawString": "}.root_5c753ca1.rootIsRequiredPlaceholderOnly_5c753ca1 .ms-TextField-fieldGroup::after{content:'*';color:" }, { "theme": "error", "defaultValue": "#a80000" }, { "rawString": ";position:absolute;top:-5px}[dir='ltr'] .root_5c753ca1.rootIsRequiredPlaceholderOnly_5c753ca1 .ms-TextField-fieldGroup::after{right:-10px}[dir='rtl'] .root_5c753ca1.rootIsRequiredPlaceholderOnly_5c753ca1 .ms-TextField-fieldGroup::after{left:-10px}.root_5c753ca1.rootIsActive_5c753ca1{border-color:" }, { "theme": "inputFocusBorderAlt", "defaultValue": "#0078d7" }, { "rawString": "}.icon_5c753ca1{pointer-events:none;position:absolute;bottom:5px;top:auto;font-size:16px;line-height:18px}html[dir='ltr'] .icon_5c753ca1{right:8px}html[dir='rtl'] .icon_5c753ca1{left:8px}.description_5c753ca1{color:" }, { "theme": "bodySubtext", "defaultValue": "#666666" }, { "rawString": ";font-size:11px}.rootIsBorderless_5c753ca1 .fieldGroup_5c753ca1{border-color:transparent;border-width:0}.root_5c753ca1.rootIsUnderlined_5c753ca1{border-width:0px}.root_5c753ca1.rootIsUnderlined_5c753ca1:hover:not(.rootIsDisabled_5c753ca1){border-color:" }, { "theme": "inputBorderHovered", "defaultValue": "#212121" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.root_5c753ca1.rootIsUnderlined_5c753ca1:hover:not(.rootIsDisabled_5c753ca1){border-color:Highlight}}.root_5c753ca1.rootIsUnderlined_5c753ca1 .wrapper_5c753ca1{display:-webkit-box;display:-ms-flexbox;display:flex;border-bottom:1px solid " }, { "theme": "inputBorder", "defaultValue": "#a6a6a6" }, { "rawString": ";width:100%}.root_5c753ca1.rootIsUnderlined_5c753ca1 .wrapper_5c753ca1.invalid_5c753ca1,.root_5c753ca1.rootIsUnderlined_5c753ca1 .wrapper_5c753ca1.invalid_5c753ca1:focus,.root_5c753ca1.rootIsUnderlined_5c753ca1 .wrapper_5c753ca1.invalid_5c753ca1:hover{border-bottom:1px solid " }, { "theme": "errorText", "defaultValue": "#a80000" }, { "rawString": "}.root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{font-size:14px;line-height:22px;height:32px}[dir='ltr'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{margin-right:8px}[dir='rtl'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{margin-left:8px}[dir='ltr'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{padding-left:12px}[dir='rtl'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{padding-right:12px}.root_5c753ca1.rootIsUnderlined_5c753ca1 .fieldGroup_5c753ca1{-webkit-box-flex:1;-ms-flex:1 1 0px;flex:1 1 0px;border-width:0}[dir='ltr'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .fieldGroup_5c753ca1{text-align:left}[dir='rtl'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .fieldGroup_5c753ca1{text-align:right}.root_5c753ca1.rootIsUnderlined_5c753ca1.rootIsDisabled_5c753ca1{border-bottom-color:" }, { "theme": "disabledBackground", "defaultValue": "#f4f4f4" }, { "rawString": "}.root_5c753ca1.rootIsUnderlined_5c753ca1.rootIsDisabled_5c753ca1 .ms-Label{color:" }, { "theme": "neutralTertiary", "defaultValue": "#a6a6a6" }, { "rawString": "}.root_5c753ca1.rootIsUnderlined_5c753ca1.rootIsDisabled_5c753ca1 .field_5c753ca1{background-color:transparent;color:" }, { "theme": "disabledText", "defaultValue": "#a6a6a6" }, { "rawString": "}.root_5c753ca1.rootIsUnderlined_5c753ca1.rootIsDisabled_5c753ca1 .fieldGroup_5c753ca1{background-color:transparent}.root_5c753ca1.rootIsUnderlined_5c753ca1.rootIsActive_5c753ca1{border-color:" }, { "theme": "inputFocusBorderAlt", "defaultValue": "#0078d7" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.root_5c753ca1.rootIsUnderlined_5c753ca1.rootIsActive_5c753ca1{border-color:Highlight}}.root_5c753ca1.rootIsMultiline_5c753ca1 .fieldGroup_5c753ca1{min-height:60px;height:auto;display:-webkit-box;display:-ms-flexbox;display:flex}.root_5c753ca1.rootIsMultiline_5c753ca1 .field_5c753ca1{line-height:17px;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;padding-top:6px;overflow:auto;width:100%}[dir='ltr'] .root_5c753ca1.rootIsMultiline_5c753ca1 .field_5c753ca1.hasIcon_5c753ca1{padding-right:40px}[dir='rtl'] .root_5c753ca1.rootIsMultiline_5c753ca1 .field_5c753ca1.hasIcon_5c753ca1{padding-left:40px}.errorMessage_5c753ca1{font-size:12px;font-weight:400;color:" }, { "theme": "errorText", "defaultValue": "#a80000" }, { "rawString": ";margin:0;padding-top:5px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.invalid_5c753ca1,.invalid_5c753ca1:focus,.invalid_5c753ca1:hover{border-color:" }, { "theme": "errorText", "defaultValue": "#a80000" }, { "rawString": "}[dir='ltr'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{padding-left:12px}[dir='rtl'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{padding-right:12px}[dir='ltr'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{padding-right:0}[dir='rtl'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .ms-Label{padding-left:0}html[dir='ltr'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .field_5c753ca1{text-align:left}html[dir='rtl'] .root_5c753ca1.rootIsUnderlined_5c753ca1 .field_5c753ca1{text-align:right}.root_5c753ca1.rootIsMultiline_5c753ca1 .icon_5c753ca1{padding-bottom:8px;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}[dir='ltr'] .root_5c753ca1.rootIsMultiline_5c753ca1 .icon_5c753ca1{padding-right:24px}[dir='rtl'] .root_5c753ca1.rootIsMultiline_5c753ca1 .icon_5c753ca1{padding-left:24px}.root_5c753ca1.rootIsMultiline_5c753ca1 .field_5c753ca1.fieldIsUnresizable_5c753ca1{resize:none}.hidden_5c753ca1{display:none}\n" }]);
exports.root = "root_5c753ca1";
exports.screenReaderOnly = "screenReaderOnly_5c753ca1";
exports.fieldGroup = "fieldGroup_5c753ca1";
exports.fieldGroupIsFocused = "fieldGroupIsFocused_5c753ca1";
exports.rootIsDisabled = "rootIsDisabled_5c753ca1";
exports.fieldPrefixSuffix = "fieldPrefixSuffix_5c753ca1";
exports.field = "field_5c753ca1";
exports.hasIcon = "hasIcon_5c753ca1";
exports.rootIsRequiredLabel = "rootIsRequiredLabel_5c753ca1";
exports.rootIsRequiredPlaceholderOnly = "rootIsRequiredPlaceholderOnly_5c753ca1";
exports.rootIsActive = "rootIsActive_5c753ca1";
exports.icon = "icon_5c753ca1";
exports.description = "description_5c753ca1";
exports.rootIsBorderless = "rootIsBorderless_5c753ca1";
exports.rootIsUnderlined = "rootIsUnderlined_5c753ca1";
exports.wrapper = "wrapper_5c753ca1";
exports.invalid = "invalid_5c753ca1";
exports.rootIsMultiline = "rootIsMultiline_5c753ca1";
exports.errorMessage = "errorMessage_5c753ca1";
exports.fieldIsUnresizable = "fieldIsUnresizable_5c753ca1";
exports.hidden = "hidden_5c753ca1";
//# sourceMappingURL=TextField.scss.js.map

/***/ }),

/***/ 1756:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(1757), exports);
tslib_1.__exportStar(__webpack_require__(1566), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1757:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
/* tslint:disable:no-unused-variable */
var React = __webpack_require__(3);
/* tslint:enable:no-unused-variable */
var Utilities_1 = __webpack_require__(7);
var index_1 = __webpack_require__(674);
var Panel_types_1 = __webpack_require__(1566);
var Layer_1 = __webpack_require__(333);
var Overlay_1 = __webpack_require__(675);
var Popup_1 = __webpack_require__(601);
var Button_1 = __webpack_require__(62);
var Styling_1 = __webpack_require__(21);
var stylesImport = __webpack_require__(1758);
var styles = stylesImport;
var theme = Styling_1.getTheme();
var Panel = /** @class */ (function (_super) {
    tslib_1.__extends(Panel, _super);
    function Panel(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isFooterSticky: false,
            isOpen: false,
            isAnimating: false,
            id: Utilities_1.getId('Panel')
        };
        return _this;
    }
    Panel.prototype.componentDidMount = function () {
        this._events.on(window, 'resize', this._updateFooterPosition);
        if (this.props.isOpen) {
            this.open();
        }
    };
    Panel.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.isOpen !== this.state.isOpen) {
            if (newProps.isOpen) {
                this.open();
            }
            else {
                this.dismiss();
            }
        }
    };
    Panel.prototype.render = function () {
        var _a = this.props, _b = _a.className, className = _b === void 0 ? '' : _b, elementToFocusOnDismiss = _a.elementToFocusOnDismiss, firstFocusableSelector = _a.firstFocusableSelector, forceFocusInsideTrap = _a.forceFocusInsideTrap, hasCloseButton = _a.hasCloseButton, headerText = _a.headerText, ignoreExternalFocusing = _a.ignoreExternalFocusing, isBlocking = _a.isBlocking, isLightDismiss = _a.isLightDismiss, isHiddenOnDismiss = _a.isHiddenOnDismiss, layerProps = _a.layerProps, type = _a.type, customWidth = _a.customWidth, _c = _a.onLightDismissClick, onLightDismissClick = _c === void 0 ? this._onPanelClick : _c, _d = _a.onRenderNavigation, onRenderNavigation = _d === void 0 ? this._onRenderNavigation : _d, _e = _a.onRenderHeader, onRenderHeader = _e === void 0 ? this._onRenderHeader : _e, _f = _a.onRenderBody, onRenderBody = _f === void 0 ? this._onRenderBody : _f, _g = _a.onRenderFooter, onRenderFooter = _g === void 0 ? this._onRenderFooter : _g;
        var _h = this.state, isOpen = _h.isOpen, isAnimating = _h.isAnimating, id = _h.id;
        var isLeft = type === Panel_types_1.PanelType.smallFixedNear ? true : false;
        var isRTL = Utilities_1.getRTL();
        var isOnRightSide = isRTL ? isLeft : !isLeft;
        var headerTextId = id + '-headerText';
        var customWidthStyles = (type === Panel_types_1.PanelType.custom) ? { width: customWidth } : {};
        var renderProps = tslib_1.__assign({}, this.props, { componentId: id });
        if (!isOpen && !isAnimating && !isHiddenOnDismiss) {
            return null;
        }
        var overlay;
        if (isBlocking && isOpen) {
            overlay = (React.createElement(Overlay_1.Overlay, { className: Utilities_1.css(styles.overlay, isOpen && isAnimating && Styling_1.AnimationClassNames.fadeIn200, !isOpen && isAnimating && Styling_1.AnimationClassNames.fadeOut200), isDarkThemed: false, onClick: isLightDismiss ? onLightDismissClick : undefined }));
        }
        return (React.createElement(Layer_1.Layer, tslib_1.__assign({}, layerProps),
            React.createElement(Popup_1.Popup, { role: 'dialog', ariaLabelledBy: headerText && headerTextId, onDismiss: this.dismiss, className: Utilities_1.css(!isOpen && !isAnimating && isHiddenOnDismiss && styles.hiddenPanel) },
                React.createElement("div", { className: Utilities_1.css('ms-Panel', styles.root, className, 
                    // because the RTL animations are not being used, we need to set a class
                    isOpen && ('is-open ' + styles.rootIsOpen), type === Panel_types_1.PanelType.smallFluid && ('ms-Panel--smFluid ' + styles.rootIsSmallFluid), type === Panel_types_1.PanelType.smallFixedNear && ('ms-Panel--smLeft ' + styles.rootIsSmallLeft), type === Panel_types_1.PanelType.smallFixedFar && ('ms-Panel--sm ' + styles.rootIsSmall), type === Panel_types_1.PanelType.medium && ('ms-Panel--md ' + styles.rootIsMedium), (type === Panel_types_1.PanelType.large || type === Panel_types_1.PanelType.largeFixed) && ('ms-Panel--lg ' + styles.rootIsLarge), type === Panel_types_1.PanelType.largeFixed && ('ms-Panel--fixed ' + styles.rootIsFixed), type === Panel_types_1.PanelType.extraLarge && ('ms-Panel--xl ' + styles.rootIsXLarge), type === Panel_types_1.PanelType.custom && ('ms-Panel--custom ' + styles.rootIsCustom), hasCloseButton && ('ms-Panel--hasCloseButton ' + styles.rootHasCloseButton), !isOpen && !isAnimating && isHiddenOnDismiss && styles.hiddenPanel) },
                    overlay,
                    React.createElement(index_1.FocusTrapZone, { className: Utilities_1.css('ms-Panel-main', styles.main, isOpen && isAnimating && !isOnRightSide && Styling_1.AnimationClassNames.slideRightIn40, isOpen && isAnimating && isOnRightSide && Styling_1.AnimationClassNames.slideLeftIn40, !isOpen && isAnimating && !isOnRightSide && Styling_1.AnimationClassNames.slideLeftOut40, !isOpen && isAnimating && isOnRightSide && Styling_1.AnimationClassNames.slideRightOut40), style: customWidthStyles, elementToFocusOnDismiss: elementToFocusOnDismiss, isClickableOutsideFocusTrap: isLightDismiss || isHiddenOnDismiss, ignoreExternalFocusing: ignoreExternalFocusing, forceFocusInsideTrap: forceFocusInsideTrap, firstFocusableSelector: firstFocusableSelector },
                        React.createElement("div", { className: Utilities_1.css('ms-Panel-commands'), "data-is-visible": true }, onRenderNavigation(renderProps, this._onRenderNavigation)),
                        React.createElement("div", { className: Utilities_1.css('ms-Panel-contentInner', styles.contentInner) },
                            onRenderHeader(renderProps, this._onRenderHeader),
                            onRenderBody(renderProps, this._onRenderBody),
                            onRenderFooter(renderProps, this._onRenderFooter)))))));
    };
    Panel.prototype.open = function () {
        var _this = this;
        if (!this.state.isOpen) {
            this.setState({
                isOpen: true,
                isAnimating: true
            }, function () {
                _this._async.setTimeout(_this._onTransitionComplete, 200);
            });
        }
    };
    Panel.prototype.dismiss = function () {
        var _this = this;
        if (this.state.isOpen) {
            this.setState({
                isOpen: false,
                isAnimating: true
            }, function () {
                _this._async.setTimeout(_this._onTransitionComplete, 200);
            });
            if (this.props.onDismiss) {
                this.props.onDismiss();
            }
        }
    };
    Panel.prototype._onRenderNavigation = function (props) {
        var closeButtonAriaLabel = props.closeButtonAriaLabel, hasCloseButton = props.hasCloseButton;
        if (hasCloseButton) {
            return (React.createElement("div", { className: Utilities_1.css('ms-Panel-navigation', styles.navigation) },
                React.createElement(Button_1.IconButton, { styles: {
                        root: {
                            height: 'auto',
                            width: '44px',
                            color: theme.palette.neutralSecondary,
                            fontSize: Styling_1.IconFontSizes.large,
                        },
                        rootHovered: {
                            color: theme.palette.neutralPrimary
                        }
                    }, className: Utilities_1.css('ms-Panel-closeButton ms-PanelAction-close'), onClick: this._onPanelClick, ariaLabel: closeButtonAriaLabel, "data-is-visible": true, iconProps: { iconName: 'Cancel' } })));
        }
        return null;
    };
    Panel.prototype._onRenderHeader = function (props) {
        var headerText = props.headerText, componentId = props.componentId, _a = props.headerClassName, headerClassName = _a === void 0 ? '' : _a;
        if (headerText) {
            return (React.createElement("div", { className: Utilities_1.css('ms-Panel-header', styles.header) },
                React.createElement("p", { className: Utilities_1.css('ms-Panel-headerText', styles.headerText, headerClassName), id: componentId + '-headerText', role: 'heading' }, headerText)));
        }
        return null;
    };
    Panel.prototype._onRenderBody = function (props) {
        var contentClass = Utilities_1.css('ms-Panel-content', styles.content, props.isFooterAtBottom && styles.contentGrow);
        return (React.createElement("div", { ref: this._resolveRef('_content'), className: contentClass }, props.children));
    };
    Panel.prototype._onRenderFooter = function (props) {
        var isFooterSticky = this.state.isFooterSticky;
        var _a = this.props.onRenderFooterContent, onRenderFooterContent = _a === void 0 ? null : _a;
        if (onRenderFooterContent) {
            return (React.createElement("div", { className: Utilities_1.css('ms-Panel-footer', styles.footer, isFooterSticky && styles.footerIsSticky) },
                React.createElement("div", { className: Utilities_1.css('ms-Panel-footerInner', styles.footerInner) }, onRenderFooterContent())));
        }
        return null;
    };
    Panel.prototype._updateFooterPosition = function () {
        var _content = this._content;
        if (_content) {
            var height = _content.clientHeight;
            var innerHeight_1 = _content.scrollHeight;
            this.setState({
                isFooterSticky: height < innerHeight_1 ? true : false
            });
        }
    };
    Panel.prototype._onPanelClick = function () {
        this.dismiss();
    };
    Panel.prototype._onTransitionComplete = function () {
        this.setState({
            isAnimating: false
        });
        if (!this.state.isOpen && this.props.onDismissed) {
            this.props.onDismissed();
        }
    };
    Panel.defaultProps = {
        isHiddenOnDismiss: false,
        isOpen: false,
        isBlocking: true,
        hasCloseButton: true,
        type: Panel_types_1.PanelType.smallFixedFar,
    };
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Panel.prototype, "dismiss", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Panel.prototype, "_onRenderNavigation", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Panel.prototype, "_onRenderHeader", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Panel.prototype, "_onRenderBody", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Panel.prototype, "_onRenderFooter", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Panel.prototype, "_onPanelClick", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Panel.prototype, "_onTransitionComplete", null);
    return Panel;
}(Utilities_1.BaseComponent));
exports.Panel = Panel;
//# sourceMappingURL=Panel.js.map

/***/ }),

/***/ 1758:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = __webpack_require__(8);
load_themed_styles_1.loadStyles([{ "rawString": ".hiddenPanel_86324e19{visibility:hidden}.root_86324e19{pointer-events:none;position:absolute;top:0;left:0;right:0;bottom:0}.root_86324e19 .overlay_86324e19{pointer-events:none;opacity:1;cursor:pointer;-webkit-transition:opacity .367s cubic-bezier(0.1, 0.9, 0.2, 1);transition:opacity .367s cubic-bezier(0.1, 0.9, 0.2, 1)}.main_86324e19{background-color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";position:absolute;width:100%;bottom:0;top:0;overflow-x:hidden;overflow-y:auto;-webkit-overflow-scrolling:touch}[dir='ltr'] .main_86324e19{right:0}[dir='rtl'] .main_86324e19{left:0}@media (min-width: 480px){.main_86324e19{border-left:1px solid " }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": ";border-right:1px solid " }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": ";pointer-events:auto;width:340px}[dir='ltr'] .main_86324e19{-webkit-box-shadow:-30px 0px 30px -30px rgba(0,0,0,0.2);box-shadow:-30px 0px 30px -30px rgba(0,0,0,0.2)}[dir='rtl'] .main_86324e19{-webkit-box-shadow:30px 0px 30px -30px rgba(0,0,0,0.2);box-shadow:30px 0px 30px -30px rgba(0,0,0,0.2)}[dir='ltr'] .main_86324e19{left:auto}[dir='rtl'] .main_86324e19{right:auto}}.root_86324e19.rootIsSmall_86324e19 .main_86324e19{width:272px}@media (min-width: 480px){.root_86324e19.rootIsSmall_86324e19 .main_86324e19{width:340px}}.root_86324e19.rootIsSmallLeft_86324e19 .main_86324e19{width:272px}[dir='ltr'] .root_86324e19.rootIsSmallLeft_86324e19 .main_86324e19{right:auto}[dir='rtl'] .root_86324e19.rootIsSmallLeft_86324e19 .main_86324e19{left:auto}[dir='ltr'] .root_86324e19.rootIsSmallLeft_86324e19 .main_86324e19{left:0}[dir='rtl'] .root_86324e19.rootIsSmallLeft_86324e19 .main_86324e19{right:0}[dir='ltr'] .root_86324e19.rootIsSmallLeft_86324e19 .main_86324e19{-webkit-box-shadow:30px 0px 30px -30px rgba(0,0,0,0.2);box-shadow:30px 0px 30px -30px rgba(0,0,0,0.2)}[dir='rtl'] .root_86324e19.rootIsSmallLeft_86324e19 .main_86324e19{-webkit-box-shadow:-30px 0px 30px -30px rgba(0,0,0,0.2);box-shadow:-30px 0px 30px -30px rgba(0,0,0,0.2)}.root_86324e19.rootIsSmallFluid_86324e19 .main_86324e19{width:100%}@media (min-width: 768px){.root_86324e19.rootIsMedium_86324e19 .main_86324e19,.root_86324e19.rootIsLarge_86324e19 .main_86324e19,.root_86324e19.rootIsXLarge_86324e19 .main_86324e19,.root_86324e19.rootIsCustom_86324e19 .main_86324e19{width:auto}[dir='ltr'] .root_86324e19.rootIsMedium_86324e19 .main_86324e19,[dir='ltr'] .root_86324e19.rootIsLarge_86324e19 .main_86324e19,[dir='ltr'] .root_86324e19.rootIsXLarge_86324e19 .main_86324e19,[dir='ltr'] .root_86324e19.rootIsCustom_86324e19 .main_86324e19{left:48px}[dir='rtl'] .root_86324e19.rootIsMedium_86324e19 .main_86324e19,[dir='rtl'] .root_86324e19.rootIsLarge_86324e19 .main_86324e19,[dir='rtl'] .root_86324e19.rootIsXLarge_86324e19 .main_86324e19,[dir='rtl'] .root_86324e19.rootIsCustom_86324e19 .main_86324e19{right:48px}}@media (min-width: 1024px){.root_86324e19.rootIsMedium_86324e19 .main_86324e19{width:643px}[dir='ltr'] .root_86324e19.rootIsMedium_86324e19 .main_86324e19{left:auto}[dir='rtl'] .root_86324e19.rootIsMedium_86324e19 .main_86324e19{right:auto}}@media (min-width: 1366px){[dir='ltr'] .root_86324e19.rootIsLarge_86324e19 .main_86324e19{left:428px}[dir='rtl'] .root_86324e19.rootIsLarge_86324e19 .main_86324e19{right:428px}}@media (min-width: 1366px){.root_86324e19.rootIsLarge_86324e19.rootIsFixed_86324e19 .main_86324e19{width:940px}[dir='ltr'] .root_86324e19.rootIsLarge_86324e19.rootIsFixed_86324e19 .main_86324e19{left:auto}[dir='rtl'] .root_86324e19.rootIsLarge_86324e19.rootIsFixed_86324e19 .main_86324e19{right:auto}}@media (min-width: 1366px){[dir='ltr'] .root_86324e19.rootIsXLarge_86324e19 .main_86324e19{left:176px}[dir='rtl'] .root_86324e19.rootIsXLarge_86324e19 .main_86324e19{right:176px}}@media (min-width: 1024px){[dir='ltr'] .root_86324e19.rootIsCustom_86324e19 .main_86324e19{left:auto}[dir='rtl'] .root_86324e19.rootIsCustom_86324e19 .main_86324e19{right:auto}}.root_86324e19.rootIsOpen_86324e19 .main_86324e19{pointer-events:auto}.root_86324e19.rootIsOpen_86324e19 .overlay_86324e19{cursor:pointer;pointer-events:auto}@media screen and (-ms-high-contrast: active){.root_86324e19.rootIsOpen_86324e19 .overlay_86324e19{opacity:0}}.navigation_86324e19{padding:0 5px;height:44px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.contentInner_86324e19{position:absolute;top:0;bottom:0;left:0;right:0;overflow-y:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-overflow-scrolling:touch;-webkit-transform:translateZ(0);transform:translateZ(0)}.rootHasCloseButton_86324e19 .contentInner_86324e19{top:44px}.header_86324e19,.content_86324e19,.footerInner_86324e19{padding-left:16px;padding-right:16px}@media (min-width: 768px){.header_86324e19,.content_86324e19,.footerInner_86324e19{padding-left:32px;padding-right:32px}}@media (min-width: 1366px){.header_86324e19,.content_86324e19,.footerInner_86324e19{padding-left:40px;padding-right:40px}}.header_86324e19{margin:14px 0;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0}@media (min-width: 1024px){.header_86324e19{margin-top:30px}}.content_86324e19{margin-bottom:0;padding-bottom:20px;overflow-y:auto}.contentGrow_86324e19{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.footer_86324e19{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;border-top:1px solid transparent;-webkit-transition:border .367s cubic-bezier(0.1, 0.25, 0.75, 0.9);transition:border .367s cubic-bezier(0.1, 0.25, 0.75, 0.9)}.footerInner_86324e19{padding-bottom:20px;padding-top:20px}.footerIsSticky_86324e19{background:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";border-top-color:" }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": "}.headerText_86324e19{font-size:21px;font-weight:100;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";line-height:32px;margin:0}\n" }]);
exports.hiddenPanel = "hiddenPanel_86324e19";
exports.root = "root_86324e19";
exports.overlay = "overlay_86324e19";
exports.main = "main_86324e19";
exports.rootIsSmall = "rootIsSmall_86324e19";
exports.rootIsSmallLeft = "rootIsSmallLeft_86324e19";
exports.rootIsSmallFluid = "rootIsSmallFluid_86324e19";
exports.rootIsMedium = "rootIsMedium_86324e19";
exports.rootIsLarge = "rootIsLarge_86324e19";
exports.rootIsXLarge = "rootIsXLarge_86324e19";
exports.rootIsCustom = "rootIsCustom_86324e19";
exports.rootIsFixed = "rootIsFixed_86324e19";
exports.rootIsOpen = "rootIsOpen_86324e19";
exports.navigation = "navigation_86324e19";
exports.contentInner = "contentInner_86324e19";
exports.rootHasCloseButton = "rootHasCloseButton_86324e19";
exports.header = "header_86324e19";
exports.content = "content_86324e19";
exports.footerInner = "footerInner_86324e19";
exports.contentGrow = "contentGrow_86324e19";
exports.footer = "footer_86324e19";
exports.footerIsSticky = "footerIsSticky_86324e19";
exports.headerText = "headerText_86324e19";
//# sourceMappingURL=Panel.scss.js.map

/***/ }),

/***/ 2050:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = __webpack_require__(6);
owa_bundling_1.preloadScriptChunk('Options');
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 2562));
});
// Export delay loaded actions
exports.lazyMountAndShowFullOptions = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.mountAndShowFullOptions; });
// Export delay loaded components
exports.QuickOptions = owa_bundling_1.createLazyComponent(lazyModule, function (m) { return m.QuickOptions; });
// Export synchronous utils
var getOptionRouteState_1 = __webpack_require__(2158);
exports.getOptionRouteState = getOptionRouteState_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2082:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DiagnosticsPane_1 = __webpack_require__(6197);
exports.DiagnosticsPane = DiagnosticsPane_1.default;
var FeatureFlagsPane_1 = __webpack_require__(6198);
exports.FeatureFlagsPane = FeatureFlagsPane_1.default;
var HelpPane_1 = __webpack_require__(6206);
exports.HelpPane = HelpPane_1.default;
var MeCardPane_1 = __webpack_require__(6210);
exports.MeCardPane = MeCardPane_1.default;
var SettingsPane_1 = __webpack_require__(6212);
exports.SettingsPane = SettingsPane_1.default;
var FeedbackPane_1 = __webpack_require__(6213);
exports.FeedbackPane = FeedbackPane_1.default;
var WafflePane_1 = __webpack_require__(6228);
exports.WafflePane = WafflePane_1.default;
var GetStartedPane_1 = __webpack_require__(6231);
exports.GetStartedPane = GetStartedPane_1.default;
//# sourceMappingURL=lazyIndex.js.map

/***/ }),

/***/ 2113:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
exports.getStore = satcheljs_1.createStore('optionsViewState', {
    isFullOptionsShown: false,
    isSaving: false,
    currentCategoryKey: null,
    currentSubCategoryKey: null,
    currentSubCategoryState: null,
    currentOptionKey: null,
    searchTerm: '',
});
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 2158:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2113);
function getOptionRouteState() {
    var store = store_1.getStore();
    return {
        isFullOptionsShown: store.isFullOptionsShown,
        currentCategoryKey: store.currentCategoryKey,
        currentSubCategoryKey: store.currentSubCategoryKey,
        currentOptionKey: store.currentOptionKey,
    };
}
exports.default = getOptionRouteState;
//# sourceMappingURL=getOptionRouteState.js.map

/***/ }),

/***/ 2217:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2248), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2248:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Utilities_1 = __webpack_require__(7);
var Label_1 = __webpack_require__(1559);
var Utilities_2 = __webpack_require__(7);
var Toggle_classNames_1 = __webpack_require__(2249);
var Toggle = /** @class */ (function (_super) {
    tslib_1.__extends(Toggle, _super);
    function Toggle(props) {
        var _this = _super.call(this) || this;
        _this._warnMutuallyExclusive({
            checked: 'defaultChecked'
        });
        _this.state = {
            isChecked: !!(props.checked || props.defaultChecked)
        };
        _this._id = props.id || Utilities_1.getId('Toggle');
        return _this;
    }
    Object.defineProperty(Toggle.prototype, "checked", {
        /**
         * Gets the current checked state of the toggle.
         */
        get: function () {
            return this.state.isChecked;
        },
        enumerable: true,
        configurable: true
    });
    Toggle.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.checked !== undefined) {
            this.setState({
                isChecked: !!newProps.checked // convert null to false
            });
        }
    };
    Toggle.prototype.render = function () {
        // This control is using an input element for more universal accessibility support.
        // Previously a button and the aria-pressed attribute were used. This technique works well with Narrator + Edge and NVDA + FireFox.
        // However, JAWS and VoiceOver did not announce anything when the toggle was checked or unchecked.
        // In the future when more screenreaders support aria-pressed it would be a good idea to change this control back to using it as it is
        // more semantically correct.
        var _a = this.props, className = _a.className, theme = _a.theme, customStyles = _a.styles, disabled = _a.disabled, label = _a.label, offAriaLabel = _a.offAriaLabel, offText = _a.offText, onAriaLabel = _a.onAriaLabel, onText = _a.onText;
        var isChecked = this.state.isChecked;
        var stateText = isChecked ? onText : offText;
        var ariaLabel = isChecked ? onAriaLabel : offAriaLabel;
        var toggleNativeProps = Utilities_1.getNativeProps(this.props, Utilities_1.inputProperties, ['defaultChecked']);
        var classNames = Toggle_classNames_1.getClassNames(theme, customStyles, className, disabled, isChecked);
        return (React.createElement("div", { className: classNames.root },
            label && (React.createElement(Label_1.Label, { htmlFor: this._id, className: classNames.label }, label)),
            React.createElement("div", { className: classNames.container },
                React.createElement("button", tslib_1.__assign({}, toggleNativeProps, { className: classNames.pill, disabled: disabled, id: this._id, type: 'button', ref: this._resolveRef('_toggleButton'), "aria-disabled": disabled, "aria-pressed": isChecked, "aria-label": ariaLabel ? ariaLabel : label, "data-is-focusable": true, onChange: this._noop, onClick: this._onClick }),
                    React.createElement("div", { className: classNames.thumb })),
                stateText && (React.createElement(Label_1.Label, { htmlFor: this._id, className: classNames.text }, stateText)))));
    };
    Toggle.prototype.focus = function () {
        if (this._toggleButton) {
            this._toggleButton.focus();
        }
    };
    Toggle.prototype._onClick = function (ev) {
        var _a = this.props, disabled = _a.disabled, checked = _a.checked, onChanged = _a.onChanged, onClick = _a.onClick;
        var isChecked = this.state.isChecked;
        if (!disabled) {
            // Only update the state if the user hasn't provided it.
            if (checked === undefined) {
                this.setState({
                    isChecked: !isChecked
                });
            }
            if (onChanged) {
                onChanged(!isChecked);
            }
            if (onClick) {
                onClick(ev);
            }
        }
    };
    Toggle.prototype._noop = function () {
        /* no-op */
    };
    tslib_1.__decorate([
        Utilities_1.autobind
    ], Toggle.prototype, "_onClick", null);
    Toggle = tslib_1.__decorate([
        Utilities_2.customizable('Toggle', ['theme'])
    ], Toggle);
    return Toggle;
}(Utilities_1.BaseComponent));
exports.Toggle = Toggle;
//# sourceMappingURL=Toggle.js.map

/***/ }),

/***/ 2249:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = __webpack_require__(7);
var Styling_1 = __webpack_require__(21);
exports.getClassNames = Utilities_1.memoizeFunction(function (theme, styles, className, disabled, checked) {
    var semanticColors = theme.semanticColors;
    var pillUncheckedBackground = semanticColors.bodyBackground;
    var pillCheckedBackground = semanticColors.inputBackgroundChecked;
    var pillCheckedHoveredBackground = semanticColors.inputBackgroundCheckedHovered;
    var pillCheckedDisabledBackground = semanticColors.disabledText;
    var thumbBackground = semanticColors.inputBorderHovered;
    var thumbCheckedBackground = semanticColors.inputForegroundChecked;
    var thumbDisabledBackground = semanticColors.disabledText;
    var thumbCheckedDisabledBackground = semanticColors.disabledBackground;
    var pillBorderColor = semanticColors.inputBorder;
    var pillBorderHoveredColor = semanticColors.inputBorderHovered;
    var pillBorderDisabledColor = semanticColors.disabledText;
    var textDisabledColor = semanticColors.disabledBodyText;
    styles = styles || {};
    return Styling_1.mergeStyleSets({
        root: [
            'ms-Toggle',
            checked && 'is-checked',
            !disabled && 'is-enabled',
            disabled && 'is-disabled',
            className,
            {
                marginBottom: '8px'
            },
            styles.root
        ],
        label: [
            'ms-Toggle-label',
            styles.label,
            disabled && {
                color: textDisabledColor,
                selectors: (_a = {},
                    _a[Styling_1.HighContrastSelector] = {
                        color: 'GrayText'
                    },
                    _a)
            }
        ],
        container: [
            'ms-Toggle-innerContainer',
            {
                display: 'inline-flex',
                position: 'relative',
            },
            styles.container
        ],
        pill: [
            'ms-Toggle-background',
            Styling_1.getFocusStyle(theme, -3),
            {
                fontSize: '20px',
                lineHeight: '1em',
                boxSizing: 'border-box',
                position: 'relative',
                width: '2.2em',
                height: '1em',
                borderRadius: '1em',
                transition: 'all 0.1s ease',
                borderWidth: '1px',
                borderStyle: 'solid',
                background: pillUncheckedBackground,
                borderColor: pillBorderColor,
                cursor: 'pointer',
            },
            styles.pill,
            !disabled && [
                !checked && {
                    selectors: {
                        ':hover': [
                            {
                                borderColor: pillBorderHoveredColor
                            },
                            styles.pillHovered
                        ],
                        ':hover .ms-Toggle-thumb': styles.thumbHovered
                    }
                },
                checked && [
                    {
                        background: pillCheckedBackground,
                        borderColor: 'transparent'
                    },
                    styles.pillChecked,
                    {
                        selectors: (_b = {
                                ':hover': [
                                    {
                                        backgroundColor: pillCheckedHoveredBackground,
                                        borderColor: 'transparent'
                                    },
                                    styles.pillCheckedHovered
                                ],
                                ':hover .ms-Toggle-thumb': [
                                    styles.thumbCheckedHovered
                                ]
                            },
                            _b[Styling_1.HighContrastSelector] = {
                                backgroundColor: 'WindowText'
                            },
                            _b)
                    }
                ]
            ],
            disabled && [
                {
                    cursor: 'default'
                },
                !checked && [
                    {
                        borderColor: pillBorderDisabledColor
                    },
                    styles.pillDisabled
                ],
                checked && [
                    {
                        backgroundColor: pillCheckedDisabledBackground,
                        borderColor: 'transparent'
                    },
                    styles.pillCheckedDisabled
                ],
            ]
        ],
        thumb: [
            'ms-Toggle-thumb',
            {
                width: '.5em',
                height: '.5em',
                borderRadius: '.5em',
                position: 'absolute',
                top: '.18em',
                transition: 'all 0.1s ease',
                backgroundColor: thumbBackground,
                /* Border is added to handle high contrast mode for Firefox */
                borderColor: 'transparent',
                borderWidth: '.28em',
                borderStyle: 'solid',
                boxSizing: 'border-box',
                left: '.2em'
            },
            styles.thumb,
            !disabled && checked && [
                {
                    backgroundColor: thumbCheckedBackground,
                    left: '1.4em',
                    selectors: (_c = {},
                        _c[Styling_1.HighContrastSelector] = {
                            backgroundColor: 'Window',
                            borderColor: 'Window'
                        },
                        _c)
                },
                styles.thumbChecked,
            ],
            disabled && [
                !checked && [
                    {
                        backgroundColor: thumbDisabledBackground,
                        left: '.2em',
                    },
                    styles.thumbDisabled
                ],
                checked && [
                    {
                        backgroundColor: thumbCheckedDisabledBackground,
                        left: '1.4em'
                    },
                    styles.thumbCheckedDisabled
                ]
            ]
        ],
        text: [
            'ms-Toggle-stateText',
            {
                selectors: {
                    // Workaround: make rules more sepecific than Label rules.
                    '&&': {
                        padding: '0',
                        margin: '0 10px',
                        userSelect: 'none',
                    }
                }
            },
            disabled && {
                selectors: {
                    '&&': {
                        color: textDisabledColor,
                        selectors: (_d = {},
                            _d[Styling_1.HighContrastSelector] = {
                                color: 'GrayText'
                            },
                            _d)
                    }
                }
            },
            styles.text
        ]
    });
    var _a, _b, _c, _d;
});
//# sourceMappingURL=Toggle.classNames.js.map

/***/ }),

/***/ 2623:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
var initialUserVoiceNpsState = {
    npsSurveyBody: '',
    npsSurveyRatings: '',
    isRatingSelected: false,
    isSent: false,
};
var initialUserVoiceSuggestionState = {
    message: '',
    isMessageEnabled: false,
    isSent: false,
};
exports.userVoiceNpsStore = satcheljs_1.createStore('UserVoiceNpsStore', initialUserVoiceNpsState)();
exports.userVoiceSuggestionStore = satcheljs_1.createStore('UserVoiceSuggestionStore', initialUserVoiceSuggestionState)();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 2681:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = __webpack_require__(6);
owa_bundling_1.preloadScriptChunk('FlexPane');
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return __webpack_require__.e/* import() */(98).then(__webpack_require__.bind(null, 2920));
});
// Export actions
exports.lazyShowFlexPane = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.mountAndShowFlexPane; });
exports.lazyHideFlexPane = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.hideFlexPane; });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2735:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.NotApplicable = 'N/A';
exports.Empty = '';
exports.CheckError = 'CheckErrorDetails';
exports.ReactNpsClientName = 'React/Nps';
exports.NpsLogDatapointId = 'UVNpsRating';
exports.FeedbackTitle = '';
exports.FeedbackLogDatapointId = 'UVFeedback';
exports.ReactFeedbackClientName = 'React/Feedback';
function GetSurveyNumber(isFirstSurvey) {
    return isFirstSurvey ? '1' : '2';
}
exports.GetSurveyNumber = GetSurveyNumber;
//# sourceMappingURL=UserVoiceConstants.js.map

/***/ }),

/***/ 2749:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var datapoint_1 = __webpack_require__(2812);
function logDatapointOperation(req, options) {
    if (req.datapoints !== undefined) {
        for (var i = 0; i < req.datapoints.length; i++) {
            if (req.datapoints[i] !== undefined && !req.datapoints[i]["__type"]) {
                req.datapoints[i] = datapoint_1.default(req.datapoints[i]);
            }
        }
    }
    return ServiceRequest_1.makeServiceRequest("LogDatapoint", req, options);
}
exports.default = logDatapointOperation;


/***/ }),

/***/ 2775:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
function getOwaNonBootUserConfigurationOperation(options) {
    return ServiceRequest_1.makeServiceRequest("GetOwaNonBootUserConfiguration", {}, options);
}
exports.default = getOwaNonBootUserConfigurationOperation;


/***/ }),

/***/ 2812:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function datapoint(data) {
    var result = tslib_1.__assign({ __type: 'Datapoint:#Exchange' }, data);
    return result;
}
exports.default = datapoint;


/***/ }),

/***/ 2914:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var resetUserVoiceSuggestion_1 = __webpack_require__(2992);
var UserVoiceSuggestion_1 = __webpack_require__(2993);
var store_1 = __webpack_require__(2623);
var postSuggestionAndSendLogDatapoint_1 = __webpack_require__(2999);
var owa_confirm_dialog_1 = __webpack_require__(223);
var owa_common_strings_1 = __webpack_require__(37);
var React = __webpack_require__(3);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('showUserVoiceSuggestionDialog')(function showUserVoiceSuggestionDialog(options) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var isConsentForm, blurb;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isConsentForm = options.ewsId !== undefined;
                    blurb = null;
                    if (!options.blurbElement) {
                        blurb = options.blurb ? options.blurb : owa_common_strings_1.default.userVoiceExplanation;
                    }
                    return [4 /*yield*/, owa_confirm_dialog_1.confirm(options.header ? options.header : owa_common_strings_1.default.userVoiceSendFeedbackTitle, blurb, false, {
                            bodyElement: (React.createElement(UserVoiceSuggestion_1.default, { isConsentForm: isConsentForm, blurbElement: options.blurbElement })),
                            preventSoftDismiss: false,
                            okText: owa_common_strings_1.default.userVoiceFeedbackSendButton,
                            cancelText: owa_common_strings_1.default.userVoiceFeedbackDiscardButton,
                            focusOnCancel: isConsentForm,
                        }).then(function (response) {
                            if (response === 0 /* ok */) {
                                postSuggestionAndSendLogDatapoint_1.default(options.title, store_1.userVoiceSuggestionStore.message, options.feedbackType, options.ewsId, options.customTags, [], null, options.userVoiceForumId);
                            }
                            resetUserVoiceSuggestion_1.default();
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=showUserVoiceSuggestionDialog.js.map

/***/ }),

/***/ 2915:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var owa_bundling_1 = __webpack_require__(6);
var owa_delayed_initialization_1 = __webpack_require__(28);
var store_1 = __webpack_require__(2916);
exports.userVoiceSettingsStore = store_1.userVoiceSettingsStore;
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return __webpack_require__.e/* import() */(103).then(__webpack_require__.bind(null, 3276));
});
// Side effects
exports.lazyGetUserVoiceData = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.getUserVoiceData; });
owa_delayed_initialization_1.runAfterInitialRender(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, exports.lazyGetUserVoiceData.import()];
            case 1:
                (_a.sent())();
                return [2 /*return*/];
        }
    });
}); });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2916:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
var initialUserVoiceSettings = {
    userVoiceId: '',
    owaUrl: '',
    onlineBookingUrl: '',
    userCulture: '',
    whenMailboxCreated: '',
    isConsumer: true,
    owaVersion: '',
    userDisplayName: '',
    country: '',
    mailboxGuid: '',
};
exports.userVoiceSettingsStore = satcheljs_1.createStore('UserVoiceSettings', initialUserVoiceSettings)();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 2955:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var owa_flex_pane_1 = __webpack_require__(2681);
var mobx_react_1 = __webpack_require__(11);
var HeaderFlexPane = /** @class */ (function (_super) {
    tslib_1.__extends(HeaderFlexPane, _super);
    function HeaderFlexPane() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderFlexPane.prototype.componentDidMount = function () {
        var _a = this.props, content = _a.content, title = _a.title, onDismiss = _a.onDismiss;
        owa_flex_pane_1.lazyShowFlexPane.importAndExecute(React.createElement("div", null, content), {
            headerText: title,
            onDismiss: onDismiss,
        });
    };
    HeaderFlexPane.prototype.componentWillUnmount = function () {
        owa_flex_pane_1.lazyHideFlexPane.importAndExecute();
    };
    HeaderFlexPane.prototype.render = function () {
        return null;
    };
    HeaderFlexPane = tslib_1.__decorate([
        mobx_react_1.observer
    ], HeaderFlexPane);
    return HeaderFlexPane;
}(React.Component));
exports.default = HeaderFlexPane;
//# sourceMappingURL=HeaderFlexPane.js.map

/***/ }),

/***/ 2991:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = __webpack_require__(6);
var showUserVoiceSuggestionDialog_1 = __webpack_require__(2914);
exports.showUserVoiceSuggestionDialog = showUserVoiceSuggestionDialog_1.default;
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return __webpack_require__.e/* import() */(89).then(__webpack_require__.bind(null, 3277));
});
exports.UserVoiceNps = owa_bundling_1.createLazyComponent(lazyModule, function (m) { return m.UserVoiceNps; });
exports.lazyShowUserVoiceSuggestionDialog = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.showUserVoiceSuggestionDialog; });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2992:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2623);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('resetUserVoiceSuggestion')(legacy_1.select({
    store: function () { return store_1.userVoiceSuggestionStore; },
})(function resetUserVoiceSuggestion(state) {
    state.store.message = '';
    state.store.isMessageEnabled = false;
    state.store.isSent = false;
}));
//# sourceMappingURL=resetUserVoiceSuggestion.js.map

/***/ }),

/***/ 2993:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var UserVoiceSuggestionForm_1 = __webpack_require__(2994);
var setUserVoiceSuggestionMessage_1 = __webpack_require__(2997);
var setUserVoiceSuggestionEnableMessage_1 = __webpack_require__(2998);
var mobx_react_1 = __webpack_require__(11);
var React = __webpack_require__(3);
var store_1 = __webpack_require__(2623);
var UserVoiceSuggestion = /** @class */ (function (_super) {
    tslib_1.__extends(UserVoiceSuggestion, _super);
    function UserVoiceSuggestion() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChangeMessage = function (message) {
            setUserVoiceSuggestionMessage_1.default(message);
        };
        _this.onChangeEnableMessage = function (enabled) {
            setUserVoiceSuggestionEnableMessage_1.default(enabled);
        };
        return _this;
    }
    UserVoiceSuggestion.prototype.render = function () {
        var message = store_1.userVoiceSuggestionStore.message, isMessageEnabled = store_1.userVoiceSuggestionStore.isMessageEnabled;
        return (React.createElement(UserVoiceSuggestionForm_1.default, { onChangeMessage: this.onChangeMessage, onChangeEnableMessage: this.onChangeEnableMessage, message: message, isConsentForm: this.props.isConsentForm, isMessageEnabled: isMessageEnabled, blurbElement: this.props.blurbElement }));
    };
    UserVoiceSuggestion = tslib_1.__decorate([
        mobx_react_1.observer
    ], UserVoiceSuggestion);
    return UserVoiceSuggestion;
}(React.Component));
exports.default = UserVoiceSuggestion;
//# sourceMappingURL=UserVoiceSuggestion.js.map

/***/ }),

/***/ 2994:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(11);
var Button_1 = __webpack_require__(62);
var TextField_1 = __webpack_require__(1741);
var React = __webpack_require__(3);
var owa_common_strings_1 = __webpack_require__(37);
var styles = __webpack_require__(2995);
var UserVoiceSuggestionForm = /** @class */ (function (_super) {
    tslib_1.__extends(UserVoiceSuggestionForm, _super);
    function UserVoiceSuggestionForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onEnableMessage = function () {
            _this.props.onChangeEnableMessage(true);
        };
        return _this;
    }
    UserVoiceSuggestionForm.prototype.render = function () {
        return (React.createElement("div", null,
            this.props.blurbElement,
            this.props.isConsentForm && !this.props.isMessageEnabled
                ? React.createElement(Button_1.Button, { buttonType: Button_1.ButtonType.command, className: styles.addDescription, onClick: this.onEnableMessage }, owa_common_strings_1.default.userVoiceFeedbackButtonTitle)
                : null,
            !this.props.isConsentForm || this.props.isMessageEnabled
                ? React.createElement(TextField_1.TextField, { multiline: true, value: this.props.message, className: styles.suggestion, onChanged: this.props.onChangeMessage, placeholder: owa_common_strings_1.default.userVoiceFeedbackPlaceholder })
                : null));
    };
    UserVoiceSuggestionForm = tslib_1.__decorate([
        mobx_react_1.observer
    ], UserVoiceSuggestionForm);
    return UserVoiceSuggestionForm;
}(React.Component));
exports.default = UserVoiceSuggestionForm;
//# sourceMappingURL=UserVoiceSuggestionForm.js.map

/***/ }),

/***/ 2995:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(2996);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 2996:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._3tRThdODpCeEaoeB4KGMr4{font-size:14px;font-weight:400;font-weight:300}._23B_y9QvG9MJ9KCwf1uN9L{font-size:12px;font-weight:400;font-weight:300;line-height:1.5}html[dir] ._23B_y9QvG9MJ9KCwf1uN9L{margin-bottom:10px}._2QxSYZQQX8tKwmnr9x5ZRl{width:100%;color:\"[theme:themePrimary, default:#0078D7]\"}html[dir] ._2QxSYZQQX8tKwmnr9x5ZRl{margin-bottom:10px}html[dir=ltr] ._2QxSYZQQX8tKwmnr9x5ZRl{padding-left:0}html[dir=rtl] ._2QxSYZQQX8tKwmnr9x5ZRl{padding-right:0}html[dir=ltr] ._2QxSYZQQX8tKwmnr9x5ZRl div{margin-left:0}html[dir=rtl] ._2QxSYZQQX8tKwmnr9x5ZRl div{margin-right:0}._2CI_r7G-IpB_6wvE13e6oB::-webkit-input-placeholder{font-size:14px;font-weight:400;font-weight:100}._2CI_r7G-IpB_6wvE13e6oB:-ms-input-placeholder{font-size:14px;font-weight:400;font-weight:100}._2CI_r7G-IpB_6wvE13e6oB::placeholder{font-size:14px;font-weight:400;font-weight:100}", ""]);

// exports
exports.locals = {
	"bodyText": "_3tRThdODpCeEaoeB4KGMr4",
	"blurb": "_23B_y9QvG9MJ9KCwf1uN9L",
	"addDescription": "_2QxSYZQQX8tKwmnr9x5ZRl",
	"suggestion": "_2CI_r7G-IpB_6wvE13e6oB"
};

/***/ }),

/***/ 2997:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2623);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('setUserVoiceSuggestionMessage')(legacy_1.select({
    store: function () { return store_1.userVoiceSuggestionStore; },
})(function setUserVoiceSuggestionMessage(message, state) {
    state.store.message = message;
}));
//# sourceMappingURL=setUserVoiceSuggestionMessage.js.map

/***/ }),

/***/ 2998:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2623);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('setUserVoiceSuggestionEnableMessage')(legacy_1.select({
    store: function () { return store_1.userVoiceSuggestionStore; },
})(function setUserVoiceSuggestionEnableMessage(enable, state) {
    state.store.isMessageEnabled = enable;
}));
//# sourceMappingURL=setUserVoiceSuggestionEnableMessage.js.map

/***/ }),

/***/ 2999:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var sendSuggestionLogDatapoint_1 = __webpack_require__(3000);
var UserVoiceConstants = __webpack_require__(2735);
var owa_analytics_1 = __webpack_require__(12);
var getOwaNonBootUserConfigurationOperation_1 = __webpack_require__(2775);
var postNewUserVoiceSuggestionOperation_1 = __webpack_require__(3001);
var owa_uservoicedata_1 = __webpack_require__(2915);
function postSuggestionAndSendLogDatapoint(title, message, feedbackType, ewsId, customTags, attachments, feedbackSentiment, forumId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var feedbackCustomTags, suggestion, suggestionResponse, errorMessage_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, owa_uservoicedata_1.lazyGetUserVoiceData.import()];
                case 1: 
                // Fetch the promise from UserVoiceData package which ensures that the settings are fetched in advance
                // And if post nps operation occurs during the GetUserVoiceData fetch operation
                // It will wait at the promise to finish.
                return [4 /*yield*/, (_a.sent())()];
                case 2:
                    // Fetch the promise from UserVoiceData package which ensures that the settings are fetched in advance
                    // And if post nps operation occurs during the GetUserVoiceData fetch operation
                    // It will wait at the promise to finish.
                    _a.sent();
                    feedbackCustomTags = customTags ? convertCustomTags(customTags) : [];
                    suggestion = {
                        Title: title,
                        Message: message.length > 0 ? message : UserVoiceConstants.NotApplicable,
                        Type: feedbackType,
                        EwsId: ewsId,
                        TicketCustomFields: feedbackCustomTags,
                        UserLocation: owa_uservoicedata_1.userVoiceSettingsStore.country,
                        MailBoxGuid: owa_uservoicedata_1.userVoiceSettingsStore.mailboxGuid,
                        Attachments: attachments,
                        FeedbackSentiment: feedbackSentiment ? feedbackSentiment : UserVoiceConstants.NotApplicable,
                        ForumId: forumId,
                    };
                    _a.label = 3;
                case 3:
                    _a.trys.push([3, 6, , 8]);
                    return [4 /*yield*/, postNewUserVoiceSuggestionOperation_1.default(suggestion)];
                case 4:
                    suggestionResponse = _a.sent();
                    return [4 /*yield*/, getOwaNonBootConfigAndLog(suggestion, suggestionResponse, UserVoiceConstants.Empty)];
                case 5:
                    _a.sent();
                    return [3 /*break*/, 8];
                case 6:
                    errorMessage_1 = _a.sent();
                    return [4 /*yield*/, getOwaNonBootConfigAndLog(suggestion, null, errorMessage_1)];
                case 7:
                    _a.sent();
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    });
}
exports.default = postSuggestionAndSendLogDatapoint;
function convertCustomTags(tags) {
    return Object.keys(tags).map(function (key) {
        return {
            Name: key,
            Value: tags[key],
        };
    });
}
function getOwaNonBootConfigAndLog(suggestion, response, error) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var suggestionId, stampStatus, owaUserConfig, licenseInfo, errorMessage_2;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    suggestionId = response ? response.PostedSuggestionId : UserVoiceConstants.CheckError;
                    stampStatus = response ? response.StampStatus : UserVoiceConstants.CheckError;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 6]);
                    return [4 /*yield*/, getOwaNonBootUserConfigurationOperation_1.default()];
                case 2:
                    owaUserConfig = _a.sent();
                    licenseInfo = owaUserConfig.ConsumerSubscriptions
                        ? owaUserConfig.ConsumerSubscriptions.join(',')
                        : UserVoiceConstants.Empty;
                    return [4 /*yield*/, logUsageAndSendDatapoint(suggestion, suggestionId, stampStatus, error, licenseInfo)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4:
                    errorMessage_2 = _a.sent();
                    return [4 /*yield*/, logUsageAndSendDatapoint(suggestion, suggestionId, stampStatus, error, UserVoiceConstants.CheckError)];
                case 5:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    });
}
function logUsageAndSendDatapoint(suggestion, suggestionId, stampStatus, error, licenseInfo) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var attachmentNames;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    attachmentNames = suggestion.Attachments
                        ? suggestion.Attachments
                            .map(function (attachment) {
                            return attachment.Name;
                        })
                            .join(' | ')
                        : '';
                    // Aria Log usage
                    return [4 /*yield*/, owa_analytics_1.logUsage(UserVoiceConstants.FeedbackLogDatapointId, [
                            suggestionId,
                            suggestion.Title,
                            suggestion.Message,
                            mapFeedbackTypeToName(suggestion.Type),
                            attachmentNames,
                            suggestion.MailBoxGuid,
                            suggestion.EwsId,
                            suggestion.UserLocation,
                            stampStatus,
                            error,
                            licenseInfo,
                            UserVoiceConstants.ReactFeedbackClientName,
                        ])];
                case 1:
                    // Aria Log usage
                    _a.sent();
                    // Suggestion Send Log Datapoint
                    return [4 /*yield*/, sendSuggestionLogDatapoint_1.sendSuggestionLogDatapoint({
                            id: suggestionId,
                            title: suggestion.Title,
                            message: suggestion.Message,
                            type: mapFeedbackTypeToName(suggestion.Type),
                            attachmentName: attachmentNames,
                            mailboxGuid: suggestion.MailBoxGuid,
                            ewsId: suggestion.EwsId,
                            userLocation: suggestion.UserLocation,
                            propsStampStatus: stampStatus,
                            error: error,
                            licenseInfo: licenseInfo,
                            forumId: suggestion.ForumId,
                        })];
                case 2:
                    // Suggestion Send Log Datapoint
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function mapFeedbackTypeToName(type) {
    switch (type) {
        case 0 /* Feedback */:
            return 'Feedback';
        case 1 /* TailoredExperiences */:
            return 'TailoredExperiences';
        case 2 /* Bookings */:
            return 'Bookings';
        case 3 /* Hashtag */:
            return 'Hashtag';
        case 4 /* Clutter */:
            return 'Clutter';
        case 5 /* Schedules */:
            return 'Schedules';
        default:
            return 'Feedback';
    }
}
//# sourceMappingURL=postSuggestionAndSendLogDatapoint.js.map

/***/ }),

/***/ 3000:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var logDatapointOperation_1 = __webpack_require__(2749);
var UserVoiceConstants = __webpack_require__(2735);
function sendSuggestionLogDatapoint(datapointProps) {
    var keys = [
        'fbid',
        'fbt',
        'fbm',
        'fbtp',
        'fbl',
        'fbe',
        'fba',
        'fbmbg',
        'fbeid',
        'fbul',
        'fbss',
        'fbfid',
    ];
    var values = [
        datapointProps.id,
        datapointProps.title,
        datapointProps.message,
        datapointProps.type,
        datapointProps.licenseInfo,
        datapointProps.error,
        datapointProps.attachmentName,
        datapointProps.mailboxGuid,
        datapointProps.ewsId ? datapointProps.ewsId : UserVoiceConstants.NotApplicable,
        datapointProps.userLocation,
        datapointProps.propsStampStatus,
        datapointProps.forumId !== undefined ? datapointProps.forumId.toString() : '0',
    ];
    var feedbackLogDatapoint = {
        Id: UserVoiceConstants.FeedbackLogDatapointId,
        Consumers: 1 /* Analytics */,
        Time: new Date(Date.now()).toString(),
        Keys: keys,
        Values: values,
    };
    return logDatapointOperation_1.default({ datapoints: [feedbackLogDatapoint] });
}
exports.sendSuggestionLogDatapoint = sendSuggestionLogDatapoint;
//# sourceMappingURL=sendSuggestionLogDatapoint.js.map

/***/ }),

/***/ 3001:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var userVoiceSuggestion_1 = __webpack_require__(3002);
function postNewUserVoiceSuggestionOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = userVoiceSuggestion_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("PostNewUserVoiceSuggestion", req, options);
}
exports.default = postNewUserVoiceSuggestionOperation;


/***/ }),

/***/ 3002:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function userVoiceSuggestion(data) {
    var result = tslib_1.__assign({ __type: 'UserVoiceSuggestion:#Exchange' }, data);
    return result;
}
exports.default = userVoiceSuggestion;


/***/ }),

/***/ 3935:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.OseFoScriptPath = 'resources/scripts/osefo.js';
exports.WidgetAppId = 'OWA';
exports.WidgetDefaultStyle = {
    bottom: '0',
    left: '0',
    height: '100%',
    width: '100%',
    position: 'absolute',
};
exports.WidgetBaseUrl = 'https://concierge.live.com';
exports.OsefoInitWidgetEvent = 'OsefoInitWidget';
exports.OsefoLoadWidgetEvent = 'OsefoLoadWidget';
exports.OsefoDismissWidgetEvent = 'OsefoDismissWidget';
exports.NotApplicableConstant = 'N/A';
exports.TicketMetaDataJsonBlobFormat = '{{"Name":"{0}", "Country":"{1}", "Premium Consumer":"{2}", "Memory usage ratio [0,1]":"{3}", "Memory.IsHighPrecision":"{4}", "Memory.JSHeapSizeLimit (MB)":"{5}", "Memory.TotalJSHeapSize (MB)":"{6}", "Memory.UsedJSHeapSize (MB)":"{7}", "Platform":"{8}", "Browser language":"{9}", "Cookie enabled":"{10}", "User agent":"{11}", "Document.Cookie":"{12}", "Mailbox culture":"{13}", "OWA layout":"{14}", "OWA UTC Start Time":"{15}", "Session length":"{16} minutes", "Focused Inbox settings":"{17}", "Versioning":"{18}", "Ring":"{19}"}}';
exports.TicketFocusedInboxMetaFormat = 'IsFocusedInboxEnabled: {0}, IsFocusedInboxCapable: {1}, FocusedInboxServerOverride: {2}, IsFocusedInboxFeatureSupported: {3}, IsFocusedInboxOnAdminOverride: {4}, IsFocusedInboxOnAdminLastUpdateTime: {5}, IsFocusedInboxOnLastUpdateTime: {6}';
exports.MiniMavenLogDatapointId = 'MiniMavenDataPoint';
exports.MiniMavenWidgetLoadTimeOut = '30000';
exports.OwaMailEventData = 'Owa Mail';
//# sourceMappingURL=HelpCharmConstants.js.map

/***/ }),

/***/ 3936:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var logDatapointOperation_1 = __webpack_require__(2749);
var HelpCharmConstants = __webpack_require__(3935);
function sendMiniMavenDataPoint(datapointProps) {
    var keys = ['mmsid', 'mmeid', 'mmlt', 'mmed', 'mmidl'];
    var values = [
        datapointProps.sessionId,
        datapointProps.eventId,
        datapointProps.loadTime,
        datapointProps.eventData,
        datapointProps.isDeeplinkScenario,
    ];
    var miniMavenLogDatapoint = {
        Id: HelpCharmConstants.MiniMavenLogDatapointId,
        Consumers: 1 /* Analytics */,
        Time: new Date(Date.now()).toString(),
        Keys: keys,
        Values: values,
    };
    return logDatapointOperation_1.default({ datapoints: [miniMavenLogDatapoint] });
}
exports.default = sendMiniMavenDataPoint;
//# sourceMappingURL=sendMiniMavenDataPoint.js.map

/***/ }),

/***/ 3937:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(6209);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 6197:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(3);
var owa_diagnostics_1 = __webpack_require__(604);
var DiagnosticsPane = function (props) {
    return React.createElement(owa_diagnostics_1.DiagnosticsPanel, { onDismiss: props.onDismiss });
};
exports.default = DiagnosticsPane;
//# sourceMappingURL=DiagnosticsPane.js.map

/***/ }),

/***/ 6198:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(3);
var FeatureFlagsHeader_1 = __webpack_require__(6199);
var FeatureFlagsList_1 = __webpack_require__(6202);
var HeaderFlexPane_1 = __webpack_require__(2955);
var FeatureFlagsPane = function (props) {
    return (React.createElement(HeaderFlexPane_1.default, { title: "Feature Flags", content: React.createElement("div", null,
            React.createElement(FeatureFlagsHeader_1.default, null),
            React.createElement(FeatureFlagsList_1.default, null)), onDismiss: props.onDismiss }));
};
exports.default = FeatureFlagsPane;
//# sourceMappingURL=FeatureFlagsPane.js.map

/***/ }),

/***/ 6199:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var owa_feature_flags_1 = __webpack_require__(54);
var mobx_react_1 = __webpack_require__(11);
var styles = __webpack_require__(6200);
var FeatureFlagsHeader = /** @class */ (function (_super) {
    tslib_1.__extends(FeatureFlagsHeader, _super);
    function FeatureFlagsHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeatureFlagsHeader.prototype.render = function () {
        return (React.createElement("div", { className: styles.container },
            React.createElement("span", { className: styles.resetButton },
                React.createElement("a", { title: "Resets all the features back to their default values", href: "#", onClick: owa_feature_flags_1.resetFeatureFlags }, "resetFlags"))));
    };
    FeatureFlagsHeader = tslib_1.__decorate([
        mobx_react_1.observer
    ], FeatureFlagsHeader);
    return FeatureFlagsHeader;
}(React.Component));
exports.default = FeatureFlagsHeader;
//# sourceMappingURL=FeatureFlagsHeader.js.map

/***/ }),

/***/ 6200:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(6201);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 6201:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, ".FRYV1WSXWdV9IDn5NzEj-{display:-webkit-box;display:-ms-flexbox;display:flex;color:\"[theme:neutralPrimary, default:#333333]\"}html[dir] .FRYV1WSXWdV9IDn5NzEj-{border-bottom:1px solid \"[theme:neutralTertiaryAlt, default:#c8c8c8]\";padding:0 5px 5px;margin-bottom:5px}.Ub0hyxKDSW-WmeLksSnv8{-webkit-box-flex:1;-ms-flex:1;flex:1}.Ub0hyxKDSW-WmeLksSnv8 a{color:\"[theme:themePrimary, default:#0078D7]\"}", ""]);

// exports
exports.locals = {
	"container": "FRYV1WSXWdV9IDn5NzEj-",
	"resetButton": "Ub0hyxKDSW-WmeLksSnv8"
};

/***/ }),

/***/ 6202:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(11);
var owa_feature_flags_1 = __webpack_require__(54);
var FeatureFlagsListItem_1 = __webpack_require__(6203);
var FeatureFlagsList = /** @class */ (function (_super) {
    tslib_1.__extends(FeatureFlagsList, _super);
    function FeatureFlagsList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeatureFlagsList.prototype.render = function () {
        return (React.createElement("div", null, owa_feature_flags_1.featureFlags
            .keys()
            .sort()
            .map(function (key) { return (React.createElement(FeatureFlagsListItem_1.default, { name: key, key: key, isOn: owa_feature_flags_1.featureFlags.get(key) })); })));
    };
    FeatureFlagsList = tslib_1.__decorate([
        mobx_react_1.observer
    ], FeatureFlagsList);
    return FeatureFlagsList;
}(React.Component));
exports.default = FeatureFlagsList;
//# sourceMappingURL=FeatureFlagsList.js.map

/***/ }),

/***/ 6203:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var owa_feature_flags_1 = __webpack_require__(54);
var mobx_react_1 = __webpack_require__(11);
var Toggle_1 = __webpack_require__(2217);
var styles = __webpack_require__(6204);
var FeatureFlagsListItem = /** @class */ (function (_super) {
    tslib_1.__extends(FeatureFlagsListItem, _super);
    function FeatureFlagsListItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeatureFlagsListItem.prototype.render = function () {
        var _a = this.props, name = _a.name, isOn = _a.isOn;
        return (React.createElement(Toggle_1.Toggle, { checked: isOn, onText: name, offText: name, className: styles.toggle, onChanged: function (value) { return owa_feature_flags_1.setFeatureFlag(name, !isOn); } }));
    };
    FeatureFlagsListItem = tslib_1.__decorate([
        mobx_react_1.observer
    ], FeatureFlagsListItem);
    return FeatureFlagsListItem;
}(React.Component));
exports.default = FeatureFlagsListItem;
//# sourceMappingURL=FeatureFlagsListItem.js.map

/***/ }),

/***/ 6204:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(6205);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 6205:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._1zB7H25cwT1ac2rN29vsLS{white-space:nowrap}html[dir] ._1zB7H25cwT1ac2rN29vsLS{padding:5px 15px;margin:0}", ""]);

// exports
exports.locals = {
	"toggle": "_1zB7H25cwT1ac2rN29vsLS"
};

/***/ }),

/***/ 6206:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var HeaderFlexPane_1 = __webpack_require__(2955);
var owa_common_strings_1 = __webpack_require__(37);
var Button_1 = __webpack_require__(62);
var mobx_react_1 = __webpack_require__(11);
var owa_uservoice_1 = __webpack_require__(2991);
var owa_controls_feature_flags_1 = __webpack_require__(33);
var owa_mail_feature_flags_1 = __webpack_require__(23);
var owa_workloads_1 = __webpack_require__(372);
var Spinner_1 = __webpack_require__(670);
var owa_help_charm_1 = __webpack_require__(6207);
var styles = __webpack_require__(3937);
// TODO: Task 659 -- Provide context-sensitive help divs
var Helpdiv = 'https://go.microsoft.com/fwlink/?linkid=853225';
var Privacydiv = 'https://go.microsoft.com/fwlink/?linkId=521839';
var Termsdiv = 'https://www.microsoft.com/en-us/servicesagreement';
var feedbackTitle = 'New feedback from Outlook.com (React)';
var consumerForumId = 601444;
var enterpriseForumId = 907141;
var HelpPane = /** @class */ (function (_super) {
    tslib_1.__extends(HelpPane, _super);
    function HelpPane() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openHelpTab = function () {
            window.open(Helpdiv, '_blank');
        };
        _this.openPrivacyTab = function () {
            window.open(Privacydiv, '_blank');
        };
        _this.openTermsTab = function () {
            window.open(Termsdiv, '_blank');
        };
        _this.launchInAppFeedback = function () {
            var isConsumer = owa_controls_feature_flags_1.isControlFeatureEnabled('doc-consumerUrl');
            owa_uservoice_1.showUserVoiceSuggestionDialog({
                title: feedbackTitle,
                feedbackType: 0 /* Feedback */,
                blurb: owa_common_strings_1.default.userVoiceExplanation,
                userVoiceForumId: isConsumer ? consumerForumId : enterpriseForumId,
            });
        };
        _this.onPaneDismiss = function () {
            owa_help_charm_1.destroyWidgetOnPaneDismiss();
            _this.props.onDismiss();
        };
        return _this;
    }
    HelpPane.prototype.render = function () {
        var _this = this;
        var isMiniMavenWidgetEnabled = owa_mail_feature_flags_1.isMailFeatureEnabled('help-miniMavenWidget');
        if (isMiniMavenWidgetEnabled) {
            owa_help_charm_1.sendMiniMavenDataPoint({
                sessionId: '',
                eventId: 'HelpPaneRendered',
                eventData: 'Owa Mail',
                loadTime: '',
                isDeeplinkScenario: '',
            });
        }
        return (React.createElement(HeaderFlexPane_1.default, { title: function () { return owa_common_strings_1.default.helpCharm_ariaLabel; }, content: React.createElement("div", null,
                isMiniMavenWidgetEnabled && (React.createElement("div", { className: styles.miniMavenWidget },
                    React.createElement("div", { ref: function (ref) { return owa_help_charm_1.loadMiniMavenHelpWidget(ref, _this.onPaneDismiss); } },
                        React.createElement(Spinner_1.Spinner, { className: styles.miniMavenWidgetLoading })))),
                React.createElement("div", { className: styles.actionsDiv },
                    React.createElement("ul", { className: styles.actions },
                        React.createElement("li", null,
                            React.createElement(Button_1.CommandButton, { onClick: this.launchInAppFeedback, text: owa_common_strings_1.default.feedbackLink, className: styles.action })),
                        !isMiniMavenWidgetEnabled && (React.createElement("li", null,
                            React.createElement(Button_1.CommandButton, { onClick: this.openHelpTab, text: owa_common_strings_1.default.helpLink, className: styles.action }))),
                        React.createElement("li", null,
                            React.createElement(Button_1.CommandButton, { onClick: this.openPrivacyTab, text: owa_common_strings_1.default.privacyLink, className: styles.action })),
                        React.createElement("li", null,
                            React.createElement(Button_1.CommandButton, { onClick: this.openTermsTab, text: owa_common_strings_1.default.termsLink, className: styles.action })),
                        owa_workloads_1.isWorkloadSupported(2 /* Calendar */) && (React.createElement("li", null,
                            React.createElement(Button_1.CommandButton, { href: "https://www.microsoft.com/concern/calendarabuse", text: owa_common_strings_1.default.reportCalendarAbuseLink, className: styles.action })))))), onDismiss: isMiniMavenWidgetEnabled ? this.onPaneDismiss : this.props.onDismiss }));
    };
    HelpPane = tslib_1.__decorate([
        mobx_react_1.observer
    ], HelpPane);
    return HelpPane;
}(React.Component));
exports.default = HelpPane;
//# sourceMappingURL=HelpPane.js.map

/***/ }),

/***/ 6207:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var loadMiniMavenHelpWidget_1 = __webpack_require__(6208);
exports.loadMiniMavenHelpWidget = loadMiniMavenHelpWidget_1.default;
exports.destroyWidgetOnPaneDismiss = loadMiniMavenHelpWidget_1.destroyWidgetOnPaneDismiss;
var sendMiniMavenDataPoint_1 = __webpack_require__(3936);
exports.sendMiniMavenDataPoint = sendMiniMavenDataPoint_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 6208:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var legacy_1 = __webpack_require__(1);
var getThemeSymbols_1 = __webpack_require__(1589);
var getPackageBaseUrl_1 = __webpack_require__(224);
var url_1 = __webpack_require__(155);
var HelpCharmConstants = __webpack_require__(3935);
var getUserConfiguration_1 = __webpack_require__(9);
var owa_strings_1 = __webpack_require__(20);
var owa_common_strings_1 = __webpack_require__(37);
var sendMiniMavenDataPoint_1 = __webpack_require__(3936);
var owa_guid_1 = __webpack_require__(585);
var onPaneDismiss;
var sessionId;
var widgetInitiationTime;
var widgetLoadFailTimeoutId;
var widgetPlaceholderDiv;
var scriptElement;
var bytesToMb = 1024 * 1024;
exports.default = legacy_1.action('loadMiniMavenHelpWidget')(function loadMiniMavenHelpWidget(hostingDivElement, onDismiss) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var userConfig_1;
        return tslib_1.__generator(this, function (_a) {
            if (hostingDivElement) {
                onPaneDismiss = onDismiss;
                widgetPlaceholderDiv = hostingDivElement;
                sessionId = owa_guid_1.getGuid();
                userConfig_1 = getUserConfiguration_1.default();
                scriptElement = document.createElement('script');
                scriptElement.src = url_1.resolve(getPackageBaseUrl_1.default(), HelpCharmConstants.OseFoScriptPath);
                scriptElement.onload = function () {
                    var clientContext = {
                        sessionId: sessionId,
                        appId: HelpCharmConstants.WidgetAppId,
                        locale: userConfig_1.SessionSettings.UserCulture,
                        hideHeader: true,
                        theme: getUserTheme(),
                        metadata: generateTicketMetaBlob(userConfig_1),
                    };
                    var widgetParams = {
                        hostingDiv: hostingDivElement,
                        baseUrl: HelpCharmConstants.WidgetBaseUrl,
                        clientContext: clientContext,
                        widgetStyle: HelpCharmConstants.WidgetDefaultStyle,
                        widgetEventListenerCallback: widgetEventListner,
                    };
                    widgetLoadFailTimeoutId = window.setTimeout(onWidgetLoadTimeout, HelpCharmConstants.MiniMavenWidgetLoadTimeOut);
                    sendMiniMavenDataPoint_1.default({
                        sessionId: sessionId,
                        eventId: 'LaunchWidget',
                        eventData: HelpCharmConstants.OwaMailEventData,
                        loadTime: '',
                        isDeeplinkScenario: '',
                    });
                    widgetInitiationTime = new Date().getTime();
                    window.Osefo.CreateWidget(widgetParams);
                };
                document.head.appendChild(scriptElement);
            }
            return [2 /*return*/];
        });
    });
});
function destroyWidgetOnPaneDismiss() {
    window.Osefo.DestroyWidget(window.Osefo.IFrameContainer.WidgetContainer);
    if (scriptElement && document.head.contains(scriptElement)) {
        document.head.removeChild(scriptElement);
    }
}
exports.destroyWidgetOnPaneDismiss = destroyWidgetOnPaneDismiss;
function getUserTheme() {
    var primaryTheme = getThemeSymbols_1.default().themePrimary;
    var darkTheme = getThemeSymbols_1.default().themeDark;
    var userTheme = {
        button: {
            bgColor: {
                onActive: primaryTheme,
                onHover: darkTheme,
            },
            borderColor: {
                onActive: primaryTheme,
                onHover: darkTheme,
            },
        },
        link: {
            color: {
                onActive: primaryTheme,
                onHover: darkTheme,
            },
        },
    };
    return userTheme;
}
function widgetEventListner(eventName) {
    if (eventName == HelpCharmConstants.OsefoDismissWidgetEvent) {
        sendMiniMavenDataPoint_1.default({
            sessionId: sessionId,
            eventId: 'OnWidgetDismissEvent',
            eventData: HelpCharmConstants.OwaMailEventData,
            loadTime: '',
            isDeeplinkScenario: '',
        });
        onPaneDismiss();
    }
    if (eventName == HelpCharmConstants.OsefoLoadWidgetEvent) {
        window.clearTimeout(widgetLoadFailTimeoutId);
        sendMiniMavenDataPoint_1.default({
            sessionId: sessionId,
            eventId: 'OnWidgetLoadEvent',
            eventData: HelpCharmConstants.OwaMailEventData,
            loadTime: String(new Date().getTime() - widgetInitiationTime),
            isDeeplinkScenario: '',
        });
    }
}
function onWidgetLoadTimeout() {
    widgetPlaceholderDiv.innerText = owa_common_strings_1.default.helpWidgetLoadFailMessage;
    sendMiniMavenDataPoint_1.default({
        sessionId: sessionId,
        eventId: 'OnWidgetLoadFailEvent',
        eventData: HelpCharmConstants.OwaMailEventData,
        loadTime: String(new Date().getTime() - widgetInitiationTime),
        isDeeplinkScenario: '',
    });
}
function generateTicketMetaBlob(userConfig) {
    var metaJsonBlob = '';
    var sessionStartTime = new Date();
    sessionStartTime.setTime(window.performance.timing.fetchStart);
    var jsHeapSizeLimit = HelpCharmConstants.NotApplicableConstant;
    var totalJSHeapSize = HelpCharmConstants.NotApplicableConstant;
    var usedJSHeapSize = HelpCharmConstants.NotApplicableConstant;
    var memoryUsageRatio = HelpCharmConstants.NotApplicableConstant;
    var isHighPrecisionMemory = HelpCharmConstants.NotApplicableConstant;
    /* tslint:disable */
    var windowPerfMemory = window.performance['memory'];
    /* tslint:enable */
    if (windowPerfMemory) {
        jsHeapSizeLimit = String((windowPerfMemory.jsHeapSizeLimit / bytesToMb) | 0);
        totalJSHeapSize = String((windowPerfMemory.totalJSHeapSize / bytesToMb) | 0);
        usedJSHeapSize = String((windowPerfMemory.usedJSHeapSize / bytesToMb) | 0);
        memoryUsageRatio = String(windowPerfMemory.usedJSHeapSize / windowPerfMemory.jsHeapSizeLimit);
        isHighPrecisionMemory = String(windowPerfMemory.usedJSHeapSize % 1000 != 0);
    }
    /*
    JSON Blob Format
    "Name"
    "Country"
    "Premium Consumer"
    "Memory usage ratio [0,1]"
    "Memory.IsHighPrecision"
    "Memory.JSHeapSizeLimit (MB)"
    "Memory.TotalJSHeapSize (MB)"
    "Memory.UsedJSHeapSize (MB)"
    "Platform"
    "Browser language"
    "Cookie enabled"
    "User agent"
    "Document.Cookie"
    "Mailbox culture"
    "OWA layout"
    "OWA UTC Start Time"
    "Session length"
    "Focused Inbox settings"
    "Versioning"
    "Ring"
    */
    metaJsonBlob = owa_strings_1.format(HelpCharmConstants.TicketMetaDataJsonBlobFormat, userConfig.SessionSettings.UserDisplayName, userConfig.UserOptions.TimeZone, String(userConfig.SessionSettings.IsPremiumConsumerMailbox), String(memoryUsageRatio), isHighPrecisionMemory, jsHeapSizeLimit, totalJSHeapSize, usedJSHeapSize, window.navigator.platform, window.navigator.language, String(window.navigator.cookieEnabled), window.navigator.userAgent, document.cookie, userConfig.SessionSettings.UserCulture, window.bootstrapOptions.app, sessionStartTime.toString(), (new Date().getTime() - window.performance.timing.fetchStart) / 60000, owa_strings_1.format(HelpCharmConstants.TicketFocusedInboxMetaFormat, String(userConfig.UserOptions.IsFocusedInboxEnabled), String(userConfig.UserOptions.IsFocusedInboxCapable), String(userConfig.UserOptions.FocusedInboxServerOverride), String(userConfig.UserOptions.IsFocusedInboxFeatureSupported), String(userConfig.UserOptions.IsFocusedInboxOnAdminOverride), userConfig.UserOptions.IsFocusedInboxOnAdminLastUpdateTime, userConfig.UserOptions.IsFocusedInboxOnLastUpdateTime), window.bootstrapDiagnostics.scriptVe, window.bootstrapDiagnostics.dring);
    return metaJsonBlob;
}
//# sourceMappingURL=loadMiniMavenHelpWidget.js.map

/***/ }),

/***/ 6209:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._1UzSPfVlxCqibAtmB6hzTs{list-style-type:none}html[dir] ._1UzSPfVlxCqibAtmB6hzTs{padding:0}._3mV-juFNOApMVQ3JThmJHH{font-weight:400;color:\"[theme:themePrimary, default:#0078D7]\";font-size:13px;cursor:pointer}html[dir] ._3mV-juFNOApMVQ3JThmJHH{padding-top:15px}._1hPfaG5GLSAvVdUPSW91pN{top:0;height:700px}html[dir=ltr] ._1hPfaG5GLSAvVdUPSW91pN{left:0}html[dir=rtl] ._1hPfaG5GLSAvVdUPSW91pN{right:0}._3jvoKvvl6LABckgv3DriWO{position:absolute}html[dir] .GXL2OGSGcTe3QTUCbWwyK{padding-top:200px}", ""]);

// exports
exports.locals = {
	"actions": "_1UzSPfVlxCqibAtmB6hzTs",
	"action": "_3mV-juFNOApMVQ3JThmJHH",
	"miniMavenWidget": "_1hPfaG5GLSAvVdUPSW91pN",
	"actionsDiv": "_3jvoKvvl6LABckgv3DriWO",
	"miniMavenWidgetLoading": "GXL2OGSGcTe3QTUCbWwyK"
};

/***/ }),

/***/ 6210:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var HeaderFlexPane_1 = __webpack_require__(2955);
var PersonaControl_1 = __webpack_require__(673);
var getUserConfiguration_1 = __webpack_require__(9);
var owa_common_strings_1 = __webpack_require__(37);
var Button_1 = __webpack_require__(62);
var Persona_1 = __webpack_require__(234);
var mobx_react_1 = __webpack_require__(11);
var signout_1 = __webpack_require__(6211);
var styles = __webpack_require__(3937);
var ConsumerLiveEditProfilePageLink = 'https://account.microsoft.com/profile';
var ConsumerLiveAccountSettingsPageLink = 'https://account.microsoft.com';
var MeCardPane = /** @class */ (function (_super) {
    tslib_1.__extends(MeCardPane, _super);
    function MeCardPane() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onEditProfileClicked = function () {
            window.open(ConsumerLiveEditProfilePageLink, '_blank');
        };
        _this.onViewAccountClicked = function () {
            window.open(ConsumerLiveAccountSettingsPageLink, '_blank');
        };
        _this.onSignoutClicked = function () {
            signout_1.signout();
        };
        return _this;
    }
    MeCardPane.prototype.componentWillUnmount = function () {
        this.props.onDismiss();
    };
    MeCardPane.prototype.render = function () {
        var userConfiguration = getUserConfiguration_1.default();
        return (React.createElement(HeaderFlexPane_1.default, { title: function () { return owa_common_strings_1.default.myAccount; }, onDismiss: this.props.onDismiss, content: React.createElement("div", null,
                React.createElement(PersonaControl_1.default, { name: userConfiguration.SessionSettings.UserDisplayName, emailAddress: userConfiguration.SessionSettings.UserEmailAddress, size: Persona_1.PersonaSize.small, showPersonaDetails: true, hexConsumerIdForUser: userConfiguration.HexCID, className: styles.persona }),
                React.createElement("ul", { className: styles.actions },
                    React.createElement("li", null,
                        React.createElement(Button_1.CommandButton, { onClick: this.onEditProfileClicked, text: owa_common_strings_1.default.editProfile, className: styles.action })),
                    React.createElement("li", null,
                        React.createElement(Button_1.CommandButton, { onClick: this.onViewAccountClicked, text: owa_common_strings_1.default.viewAccount, className: styles.action })),
                    React.createElement("li", null,
                        React.createElement(Button_1.CommandButton, { onClick: this.onSignoutClicked, text: owa_common_strings_1.default.signOut, className: styles.action })))) }));
    };
    MeCardPane = tslib_1.__decorate([
        mobx_react_1.observer
    ], MeCardPane);
    return MeCardPane;
}(React.Component));
exports.default = MeCardPane;
//# sourceMappingURL=MeCardPane.js.map

/***/ }),

/***/ 6211:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getUserConfiguration_1 = __webpack_require__(9);
var legacy_1 = __webpack_require__(1);
var signoutUrl = '/owa/logoff.owa';
exports.signout = legacy_1.action('signout')(function signout() {
    var userConfiguration = getUserConfiguration_1.default();
    if (userConfiguration.ApplicationSettings.CloseWindowOnLogout) {
        // TODO: Task 644 - Put up message box saying to sign out by closing all windows.
        // Only needed for on-prem
    }
    location.assign(signoutUrl);
});
//# sourceMappingURL=signout.js.map

/***/ }),

/***/ 6212:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var HeaderFlexPane_1 = __webpack_require__(2955);
var owa_options_strings_1 = __webpack_require__(1737);
var owa_options_view_1 = __webpack_require__(2050);
var mobx_react_1 = __webpack_require__(11);
var SettingsPane = /** @class */ (function (_super) {
    tslib_1.__extends(SettingsPane, _super);
    function SettingsPane() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SettingsPane.prototype.render = function () {
        return (React.createElement(HeaderFlexPane_1.default, { title: function () { return owa_options_strings_1.default.optionsFlex_title; }, content: React.createElement(owa_options_view_1.QuickOptions, { onDismiss: this.props.onDismiss }), onDismiss: this.props.onDismiss }));
    };
    SettingsPane = tslib_1.__decorate([
        mobx_react_1.observer
    ], SettingsPane);
    return SettingsPane;
}(React.Component));
exports.default = SettingsPane;
//# sourceMappingURL=SettingsPane.js.map

/***/ }),

/***/ 6213:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var HeaderFlexPane_1 = __webpack_require__(2955);
var owa_common_strings_1 = __webpack_require__(37);
var owa_feedback_1 = __webpack_require__(6214);
var mobx_react_1 = __webpack_require__(11);
var styles = __webpack_require__(6226);
var FeedbackPane = /** @class */ (function (_super) {
    tslib_1.__extends(FeedbackPane, _super);
    function FeedbackPane() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSend = function () {
            _this.props.onDismiss();
        };
        return _this;
    }
    FeedbackPane.prototype.renderFeedbackForm = function () {
        return (React.createElement("div", { className: styles.menuFeedback },
            React.createElement(owa_feedback_1.FeedbackForm, { onSendFeedback: this.onSend })));
    };
    FeedbackPane.prototype.render = function () {
        return (React.createElement(HeaderFlexPane_1.default, { title: function () { return owa_common_strings_1.default.feedbackCharm_ariaLabel; }, content: this.renderFeedbackForm(), onDismiss: this.props.onDismiss }));
    };
    FeedbackPane = tslib_1.__decorate([
        mobx_react_1.observer
    ], FeedbackPane);
    return FeedbackPane;
}(React.Component));
exports.default = FeedbackPane;
//# sourceMappingURL=FeedbackPane.js.map

/***/ }),

/***/ 6214:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = __webpack_require__(6);
owa_bundling_1.preloadScriptChunk('FeedbackForm');
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return __webpack_require__.e/* import() */(92).then(__webpack_require__.bind(null, 6215));
});
exports.FeedbackForm = owa_bundling_1.createLazyComponent(lazyModule, function (m) { return m.FeedbackForm; });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 6226:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(6227);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 6227:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._1LGPhYAQJgMwHZjoMTLUCV{min-width:276px}._2qd8K10f-G5_xlMTXky4wM{width:100%}html[dir] ._2qd8K10f-G5_xlMTXky4wM{margin-top:15px}", ""]);

// exports
exports.locals = {
	"menuFeedback": "_1LGPhYAQJgMwHZjoMTLUCV",
	"sendButton": "_2qd8K10f-G5_xlMTXky4wM"
};

/***/ }),

/***/ 6228:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var Icon_1 = __webpack_require__(43);
var mobx_1 = __webpack_require__(15);
var mobx_react_1 = __webpack_require__(11);
var Panel_1 = __webpack_require__(1747);
var owa_accessibility_1 = __webpack_require__(79);
var owa_controls_feature_flags_1 = __webpack_require__(33);
var owa_header_store_1 = __webpack_require__(1608);
var owa_common_strings_1 = __webpack_require__(37);
var hostLocation_1 = __webpack_require__(73);
var React = __webpack_require__(3);
var owa_url_1 = __webpack_require__(216);
var getUserConfiguration_1 = __webpack_require__(9);
var styles = __webpack_require__(6229);
var classNames = __webpack_require__(30);
var indexedReactDefaultPage = owa_url_1.getMailPath() + 'default.aspx';
var indexedCalendarDefaultPage = owa_url_1.getCalendarPath() + 'default.aspx';
var indexedPeopleDefaultPage = owa_url_1.getPeoplePath() + 'default.aspx';
function createAppTile(displayName, icon, consumerHref, enterpriseHref, hoverBackground) {
    return {
        displayName: displayName,
        icon: icon,
        href: owa_controls_feature_flags_1.isControlFeatureEnabled('fwk-consumerWaffle') ? consumerHref : enterpriseHref,
        hoverBackground: hoverBackground,
    };
}
function getUrlWithAbsolutePath(pageRelativePath) {
    return hostLocation_1.getHostLocation().href.replace(hostLocation_1.getHostLocation().pathname, pageRelativePath);
}
function isOwaMailReactLocation() {
    var lowercasePathname = hostLocation_1.getHostLocation().pathname.toLowerCase();
    if (lowercasePathname === owa_url_1.getMailPath() || lowercasePathname === indexedReactDefaultPage) {
        return true;
    }
    return false;
}
function isOwaCalendarReactLocation() {
    var lowercasePathname = hostLocation_1.getHostLocation().pathname.toLowerCase();
    if (lowercasePathname === owa_url_1.getCalendarPath() ||
        lowercasePathname === indexedCalendarDefaultPage) {
        return true;
    }
    return false;
}
function isOwaPeopleReactLocation() {
    var lowercasePathname = hostLocation_1.getHostLocation().pathname.toLowerCase();
    if (lowercasePathname === owa_url_1.getPeoplePath() || lowercasePathname === indexedPeopleDefaultPage) {
        return true;
    }
    return false;
}
function isPhotoHubReactLocation() {
    var lowercasePathname = hostLocation_1.getHostLocation().pathname.toLowerCase();
    if (lowercasePathname === owa_url_1.getPhotoHubPath()) {
        return true;
    }
    return false;
}
function isFilesHubReactLocation() {
    var lowercasePathname = hostLocation_1.getHostLocation().pathname.toLowerCase();
    if (lowercasePathname === owa_url_1.getFilesHubPath()) {
        return true;
    }
    return false;
}
function getMailAppHref() {
    return isOwaMailReactLocation() ? '' : getUrlWithAbsolutePath(owa_url_1.getMailPath());
}
function getPhotoHubAppHref() {
    return isPhotoHubReactLocation() ? '' : getUrlWithAbsolutePath(owa_url_1.getPhotoHubPath());
}
function getFilesHubAppHref() {
    return isFilesHubReactLocation() ? '' : getUrlWithAbsolutePath(owa_url_1.getFilesHubPath());
}
function getCalendarAppHref() {
    return isOwaCalendarReactLocation() ? '' : getUrlWithAbsolutePath(owa_url_1.getCalendarPath());
}
function getPeopleAppHref() {
    return isOwaPeopleReactLocation() ? '' : hostLocation_1.getHostLocation().origin + owa_url_1.getPeoplePath();
}
function createPhotoOrFilesHubAppTile() {
    var isFilesHubEnabled = owa_controls_feature_flags_1.isControlFeatureEnabled('doc-fileshub');
    var appHRef = isFilesHubEnabled ? getFilesHubAppHref() : getPhotoHubAppHref();
    return createAppTile(isFilesHubEnabled ? 'Files' : owa_common_strings_1.default.appPhotos, // TODO: Localize (Bug: 23430)
    isFilesHubEnabled ? "Attach" /* Attach */ : "Photo2" /* Photo2 */, appHRef, appHRef, styles.appFilesPhoto);
}
function isCalendarFlightSettingEnabled() {
    var userOptions = getUserConfiguration_1.default().UserOptions;
    if (userOptions && userOptions.ReactOptinSettings) {
        return userOptions.ReactOptinSettings.CalendarEnabled;
    }
    else {
        return false;
    }
}
function isPeopleFlightSettingEnabled() {
    var userOptions = getUserConfiguration_1.default().UserOptions;
    if (userOptions && userOptions.ReactOptinSettings) {
        return userOptions.ReactOptinSettings.PeopleEnabled;
    }
    else {
        return false;
    }
}
var Apps = mobx_1.computed(function () {
    return [
        createAppTile(owa_common_strings_1.default.appMail, "Mail" /* Mail */, getMailAppHref(), getMailAppHref(), styles.appMail),
        createAppTile(owa_common_strings_1.default.appCalendar, "Calendar" /* Calendar */, owa_controls_feature_flags_1.isControlFeatureEnabled('cal-react') || isCalendarFlightSettingEnabled()
            ? getCalendarAppHref()
            : owa_url_1.getOwaUrlWithAddedQueryParameters({ path: '/calendar' }), owa_controls_feature_flags_1.isControlFeatureEnabled('cal-react') || isCalendarFlightSettingEnabled()
            ? getCalendarAppHref()
            : owa_url_1.getOwaUrlWithAddedQueryParameters({ path: '/calendar' }), styles.appCalendar),
        createAppTile(owa_common_strings_1.default.appPeople, "People" /* People */, owa_controls_feature_flags_1.isControlFeatureEnabled('fwk-peopleReact') || isPeopleFlightSettingEnabled()
            ? getPeopleAppHref()
            : owa_url_1.getOwaUrlWithAddedQueryParameters({ path: '/people' }), owa_controls_feature_flags_1.isControlFeatureEnabled('fwk-peopleReact') || isPeopleFlightSettingEnabled()
            ? getPeopleAppHref()
            : owa_url_1.getOwaUrlWithAddedQueryParameters({ path: '/people' }), styles.appPeople),
    ]
        .concat(owa_controls_feature_flags_1.isControlFeatureEnabled('doc-photohub') || owa_controls_feature_flags_1.isControlFeatureEnabled('doc-fileshub')
        ? [createPhotoOrFilesHubAppTile()]
        : [])
        .concat([
        createAppTile(owa_common_strings_1.default.appOneDrive, "OneDrive" /* OneDrive */, 'https://onedrive.live.com', 'https://microsoft-my.sharepoint.com/_layouts/15/MySite.aspx?MySiteRedirect=AllDocuments', styles.appOneDrive),
        createAppTile(owa_common_strings_1.default.appTasks, "CheckboxComposite" /* CheckboxComposite */, owa_url_1.getOwaUrlWithAddedQueryParameters({ path: '/tasks' }), owa_url_1.getOwaUrlWithAddedQueryParameters({ path: '/tasks' }), styles.appTasks),
        createAppTile(owa_common_strings_1.default.appWord, "WordLogo" /* WordLogo */, 'https://office.live.com/start/Word.aspx?auth=1', 'https://office.live.com/start/Word.aspx?auth=2', styles.appWord),
        createAppTile(owa_common_strings_1.default.appExcel, "ExcelLogo" /* ExcelLogo */, 'https://office.live.com/start/Excel.aspx?auth=1', 'https://office.live.com/start/Excel.aspx?auth=2', styles.appExcel),
        createAppTile(owa_common_strings_1.default.appPowerPoint, "PowerPointLogo" /* PowerPointLogo */, 'https://office.live.com/start/PowerPoint.aspx?auth=1', 'https://office.live.com/start/PowerPoint.aspx?auth=2', styles.appPowerPoint),
        createAppTile(owa_common_strings_1.default.appOneNote, "OneNoteLogo" /* OneNoteLogo */, 'https://www.onenote.com/notebooks?auth=1', 'https://www.onenote.com/notebooks?auth=2', styles.appOneNote),
        createAppTile(owa_common_strings_1.default.appSway, "SwayLogoInverse" /* SwayLogoInverse */, 'https://sway.com', 'https://sway.com', styles.appSway),
    ])
        .concat(owa_controls_feature_flags_1.isControlFeatureEnabled('fwk-consumerWaffle')
        ? [
            createAppTile(owa_common_strings_1.default.appSkype, "SkypeLogo" /* SkypeLogo */, 'https://web.skype.com/?source=owa', '', styles.appSkype),
            createAppTile(owa_common_strings_1.default.appOffice, "OfficeLogo" /* OfficeLogo */, 'https://office.live.com/start/default.aspx?auth=1&nf=1', '', styles.appOffice),
            createAppTile(owa_common_strings_1.default.appBing, "BingLogo" /* BingLogo */, 'https://www.bing.com/?FORM=MO0027', '', styles.appBing),
            createAppTile(owa_common_strings_1.default.appMSN, "MsnLogo" /* MsnLogo */, 'https://www.msn.com/?OCID=CALHeader', '', styles.appMSN),
            createAppTile(owa_common_strings_1.default.appFlow, "Flow" /* Flow */, 'https://flow.microsoft.com/manage/?utm_source=consumer_office&utm_medium=app_launcher&utm_campaign=consumer_referrals', '', styles.appFlow),
        ]
        : [])
        .concat(owa_controls_feature_flags_1.isControlFeatureEnabled('fwk-bookingsModule')
        ? [
            createAppTile(owa_common_strings_1.default.appBookings, "BookingsLogo" /* BookingsLogo */, owa_url_1.getOwaUrlWithAddedQueryParameters({ path: '/bookings' }), owa_url_1.getOwaUrlWithAddedQueryParameters({ path: '/bookings' }), styles.appBookings),
        ]
        : []);
});
var AppsContextMenu = mobx_react_1.observer(function (props) { return (React.createElement("div", { className: styles.appsContainer }, Apps.get().map(function (appTile) {
    var tileClasses = classNames(styles.app, appTile.hoverBackground);
    var ariaProps = {
        role: owa_accessibility_1.AriaRoles.menuitem,
        label: appTile.displayName,
    };
    return (React.createElement("a", tslib_1.__assign({ "data-is-focusable": true, href: appTile.href, target: '_blank', className: tileClasses, onClick: props.onDismiss }, owa_accessibility_1.generateDomPropertiesForAria(ariaProps)),
        React.createElement(Icon_1.Icon, { className: styles.icon, iconName: appTile.icon }),
        React.createElement("div", { className: styles.text }, appTile.displayName)));
}))); });
var WaffleCharm = /** @class */ (function (_super) {
    tslib_1.__extends(WaffleCharm, _super);
    function WaffleCharm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WaffleCharm.prototype.render = function () {
        return (React.createElement(Panel_1.Panel, { className: styles.appPane, isLightDismiss: true, isOpen: owa_header_store_1.headerStore.activeCharm === 5 /* WaffleCharm */, hasCloseButton: false, onDismiss: this.props.onDismiss, type: Panel_1.PanelType.smallFixedNear },
            React.createElement(AppsContextMenu, { onDismiss: this.props.onDismiss })));
    };
    WaffleCharm = tslib_1.__decorate([
        mobx_react_1.observer
    ], WaffleCharm);
    return WaffleCharm;
}(React.Component));
exports.default = WaffleCharm;
//# sourceMappingURL=WafflePane.js.map

/***/ }),

/***/ 6229:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(6230);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 6230:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._3qu9yWIrzHNWJBINh1UVbd{top:48px}._3qu9yWIrzHNWJBINh1UVbd .ms-Panel-main{width:320px!important}html[dir] ._3qu9yWIrzHNWJBINh1UVbd .ms-Panel-main{border-color:\"[theme:white, default:#ffffff]\"}html[dir] ._3qu9yWIrzHNWJBINh1UVbd .ms-Panel-contentInner{background-color:\"[theme:white, default:#ffffff]\"}html[dir] ._3qu9yWIrzHNWJBINh1UVbd .ms-Panel-content{padding:0}._21T0VQ9tib3BQDxNrjdABk{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}html[dir=ltr] ._21T0VQ9tib3BQDxNrjdABk{margin:23px 0 0 23px}html[dir=rtl] ._21T0VQ9tib3BQDxNrjdABk{margin:23px 23px 0 0}._3jLeQHtoJYe1-TbQlA4dYa{font-size:12px;font-weight:400;width:88px;height:88px;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-decoration:none}html[dir] ._3jLeQHtoJYe1-TbQlA4dYa{background:\"[theme:neutralLighterAlt, default:#f8f8f8]\"}html[dir=ltr] ._3jLeQHtoJYe1-TbQlA4dYa{margin:0 5px 5px 0}html[dir=rtl] ._3jLeQHtoJYe1-TbQlA4dYa{margin:0 0 5px 5px}._2HHKLdtGkjq7NIGsTumNjf{font-size:36px}html[dir] ._2HHKLdtGkjq7NIGsTumNjf{padding-bottom:10px}._1kV7BFdc-lpcrPPp89fdj6,._3botd9_h4OJg56674gTrVM,._3StrjkrxVAQL5SMWnrCJ4D,._227i_sMDWxOKo5TVdbmXfO,.Bn3vfxyQlShzVxF-5Twd3{color:\"[theme:themePrimary, default:#0078D7]\"}html[dir] ._1kV7BFdc-lpcrPPp89fdj6:hover,html[dir] ._3botd9_h4OJg56674gTrVM:hover,html[dir] ._3StrjkrxVAQL5SMWnrCJ4D:hover,html[dir] ._227i_sMDWxOKo5TVdbmXfO:hover,html[dir] .Bn3vfxyQlShzVxF-5Twd3:hover{background-color:\"[theme:themePrimary, default:#0078D7]\"}.Su1Asdj3rzaBSJe4_57JN{color:#094ab2}html[dir] .Su1Asdj3rzaBSJe4_57JN:hover{background-color:#094ab2}._24An0igZHIj2ehQ5PkIGe6{color:#2b579a}html[dir] ._24An0igZHIj2ehQ5PkIGe6:hover{background-color:#2b579a}._3QG7XW23wcDWfoIKJ1XOdW{color:#217346}html[dir] ._3QG7XW23wcDWfoIKJ1XOdW:hover{background-color:#217346}._8j-_hfHLQLcjmQouKcOip{color:#d24726}html[dir] ._8j-_hfHLQLcjmQouKcOip:hover{background-color:#d24726}._2j879E1Hzbtef8QfBK7PrW{color:#80397b}html[dir] ._2j879E1Hzbtef8QfBK7PrW:hover{background-color:#80397b}._381HY1YqNZH7WNebhJpxGY{color:#008272}html[dir] ._381HY1YqNZH7WNebhJpxGY:hover{background-color:#008272}._1y3qcIiSrv24gjHxcoVfF6{color:#00aff0}html[dir] ._1y3qcIiSrv24gjHxcoVfF6:hover{background-color:#00aff0}._1OiqNnhAKl83tXf0Alss1n{color:#d83b01}html[dir] ._1OiqNnhAKl83tXf0Alss1n:hover{background-color:#d83b01}.T48IzTj5Q8F4D-WeA47Oc{color:#0c8484}html[dir] .T48IzTj5Q8F4D-WeA47Oc:hover{background-color:#0c8484}._1WP9yHlCNHGfb4Fd5qDzZ8{color:#1e1e1e}html[dir] ._1WP9yHlCNHGfb4Fd5qDzZ8:hover{background-color:#1e1e1e}._1czm_t0LH448Rd2z82crMr{color:#07f}html[dir] ._1czm_t0LH448Rd2z82crMr:hover{background-color:#07f}._3iK607G48_9MtD2iiWDMxr{color:#33bab1}html[dir] ._3iK607G48_9MtD2iiWDMxr:hover{background-color:#33bab1}.R2rIkKsFzhzQ3x-HYN0Wb{color:\"[theme:neutralSecondary, default:#666666]\"}._3jLeQHtoJYe1-TbQlA4dYa:hover ._2HHKLdtGkjq7NIGsTumNjf,._3jLeQHtoJYe1-TbQlA4dYa:hover .R2rIkKsFzhzQ3x-HYN0Wb{color:\"[theme:white, default:#ffffff]\"}", ""]);

// exports
exports.locals = {
	"appPane": "_3qu9yWIrzHNWJBINh1UVbd",
	"appsContainer": "_21T0VQ9tib3BQDxNrjdABk",
	"app": "_3jLeQHtoJYe1-TbQlA4dYa",
	"icon": "_2HHKLdtGkjq7NIGsTumNjf",
	"appMail": "_1kV7BFdc-lpcrPPp89fdj6",
	"appCalendar": "_3botd9_h4OJg56674gTrVM",
	"appPeople": "_227i_sMDWxOKo5TVdbmXfO",
	"appFilesPhoto": "_3StrjkrxVAQL5SMWnrCJ4D",
	"appTasks": "Bn3vfxyQlShzVxF-5Twd3",
	"appOneDrive": "Su1Asdj3rzaBSJe4_57JN",
	"appWord": "_24An0igZHIj2ehQ5PkIGe6",
	"appExcel": "_3QG7XW23wcDWfoIKJ1XOdW",
	"appPowerPoint": "_8j-_hfHLQLcjmQouKcOip",
	"appOneNote": "_2j879E1Hzbtef8QfBK7PrW",
	"appSway": "_381HY1YqNZH7WNebhJpxGY",
	"appSkype": "_1y3qcIiSrv24gjHxcoVfF6",
	"appOffice": "_1OiqNnhAKl83tXf0Alss1n",
	"appBing": "T48IzTj5Q8F4D-WeA47Oc",
	"appMSN": "_1WP9yHlCNHGfb4Fd5qDzZ8",
	"appFlow": "_1czm_t0LH448Rd2z82crMr",
	"appBookings": "_3iK607G48_9MtD2iiWDMxr",
	"text": "R2rIkKsFzhzQ3x-HYN0Wb"
};

/***/ }),

/***/ 6231:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var HeaderFlexPane_1 = __webpack_require__(2955);
var mobx_react_1 = __webpack_require__(11);
var owa_get_started_1 = __webpack_require__(1639);
var owa_getstarted_strings_1 = __webpack_require__(1637);
var owa_analytics_1 = __webpack_require__(12);
var GetStartedPane = /** @class */ (function (_super) {
    tslib_1.__extends(GetStartedPane, _super);
    function GetStartedPane(props) {
        return _super.call(this, props) || this;
    }
    GetStartedPane.prototype.render = function () {
        var _this = this;
        owa_analytics_1.logUsage('getStartedPaneOpened');
        return (React.createElement(HeaderFlexPane_1.default, { title: owa_getstarted_strings_1.default.getStarted_FlexPane_Title, content: React.createElement(owa_get_started_1.GetStartedTaskContainer, null), onDismiss: function () {
                _this.props.onDismiss();
            } }));
    };
    GetStartedPane = tslib_1.__decorate([
        mobx_react_1.observer
    ], GetStartedPane);
    return GetStartedPane;
}(React.Component));
exports.default = GetStartedPane;
//# sourceMappingURL=GetStartedPane.js.map

/***/ })

});


// WEBPACK FOOTER //
// owa.HeaderPane.js